import { ErrorLevel, setErrorLevelAddOn } from '../../../core/forms/helpers/errorLevelTools';
import { fn2nZ } from '../../../core/formatter/formatNumber';
import { getOrt } from '../../../helpers/getOrt';
import { getPlausiValue } from '../../../main/functions//plausibilisierung';
import { getWaermeKwh } from '../../../main/functions/getWaermeKwh';
import { IDs } from '../../../helpers/IDs';
import { isFieldHidden } from './isFieldHidden';
import { isValid } from '../../../main/functions/validData';
import { isValid as isValidKennzahl } from '../../../main/functions/validKennzahl';
import { isValid as isValidZaehlerwert } from '../../../main/functions/validZaehlerwert';
import { isProduzierendesGewerbe } from '../../../main/functions/getGewerk';
import Moment from 'moment';
import * as config from '../../../wips.config.js';

const formatFloat: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true });
const formatFloat2: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true });
let errorType: string;

const sysTxtAZMehrAlsEinMonat = 'Der Abrechnungszeitraum reicht mehr als einen Monat in das';
const sysTxtSteuerAZNichtEinJahr = 'Der Abrechnungszeitraum beträgt nicht ein Jahr.';
const sysTxtPvScope3_2 = 'Für Photovoltaikanlagen steht die Dateneingabe in Scope 3.2 nicht zur Verfügung.';
const sysTxtKeinProduGewerbe = 'Kein produzierendes Gewerbe';

export function isSomeKindOfNumber(value: any) {
    if (value !== null && value !== undefined && value !== '' && !isNaN(+value)) {
        return true;
    }
    return false;
}

export function validateFieldUniversal(
    entity: string, key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any,
    callback?: (data: any) => void
): string {
    const noCheckKeys: any = {
        art_hersteller: true,
        erfasst_von: true,
        hersteller: true,
        institution: true,
        kalibrierung: true,
        messsystem: true,
        modul: true,
        name: true,
        stromanbieter: true,
        wechselrichter: true,
        plz: true,
        hausnummer: true
    };
    const deactivate = false;
    if (deactivate) {
        return null;
    }
    if ((((data || {}).values || {}).bemerkung || '').toString().includes('DS korrekt')) {
        return null;
    }
    const value_check = +value;
    if (isFieldHidden(entity, key, data.values || {}, dataGlobal)) {
        return null;
    }
    if (isNaN(value_check) || value === undefined || value === null || (value.trim && value.trim() === '') || noCheckKeys[key]) {
        // Value einfach nicht ändern
    } else {
        value = value_check;
    }

    const getValidMsg = () => {
        switch (entity) {
            case IDs.ENT_ANGEMIETETE_FAHRZEUGE:
                return validateFieldAngemieteteFahrzeuge(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_ANGEMIETETE_RAEUMLICHKEITEN: // no break
            case IDs.ENT_EIGENE_RAEUMLICHKEITEN:
                return validateFieldRaeumlichkeiten(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_ANLAGEN_EIGENSTROM_BIOMASSE:
                return validateFieldEigenstromBiomasse(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_ANLAGEN_EIGENSTROM_KWK:
                return validateFieldEigenstromKwk(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_ANLAGEN_EIGENSTROM_PHOTOVOLTAIK:
                return validateFieldEigenstromPhotovoltaik(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_ANLAGEN_EIGENSTROM_SOLARTHERMIE:
                return validateFieldEigenstromSolarthermie(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_ANLAGEN_EIGENSTROM_WAERMEPUMPEN:
                return validateFieldEigenstromWaermepumpen(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_ANLAGEN_EIGENSTROM_WINDKRAFT:
                return validateFieldEigenstromWindkraft(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_BETRIEBSDATEN:
                return validateFieldBetriebsdaten(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CFM_MOTIVATION:
                return validateFieldCfmMotivation(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_ABFALL:
                return validateFieldCO2Scope3Abfall(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_ANGEMIETETE_SACHANLAGEN:
                return validateFieldCO2Scope3AngemieteteSachanlagen(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_EMITTENTEN:
                return validateFieldCO2Scope3Emittenten(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_FRANCHISE:
                return validateFieldCO2Scope3Franchise(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_GUETER_EINKAUF:
                return validateFieldCO2Scope3GueterEinkauf(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_GUETER_KAPITAL:
                return validateFieldCO2Scope3GueterKapital(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_INVESTITION:
                return validateFieldCO2Scope3Investition(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_LIEFERANT:
                return validateFieldCO2Scope3Lieferant(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_PENDELN:
                return validateFieldCO2Scope3Pendeln(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_PRODUKTE_LEBENSZYKLUS: // no break
            case IDs.ENT_CO2_SCOPE3_PRODUKTE_NUTZUNG: // no break
            case IDs.ENT_CO2_SCOPE3_PRODUKTE_VERARBEITUNG:
                return validateFieldCO2Scope3Produkte(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_REISEN:
                return validateFieldCO2Scope3Reisen(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_NACHGELAGERT:
                return validateFieldCO2Scope3TransportNachgelagert(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_TRANSPORT_VORGELAGERT:
                return validateFieldCO2Scope3TransportVorgelagert(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN:
                return validateFieldCO2Scope3VermieteteSachanlagen(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_FAHRZEUGE:
                return validateFieldCO2Scope3VermieteteSachanlagenFahrzeuge(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_RAEUMLICHKEITEN:
                return validateFieldCO2Scope3VermieteteSachanlagenRaeumlichkeiten(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_CO2_SCOPE3_VERMIETETE_SACHANLAGEN_TECHNIK:
                return validateFieldCO2Scope3VermieteteSachanlagenTechnik(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_ENERGIEDATEN_EIGENSTROM:
                return validateFieldEigenstrom(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE:
                return validateFieldKraftstoffe(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_ENERGIEDATEN_STROM:
                return validateFieldStrom(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_ENERGIEDATEN_WAERME:
                return validateFieldWaerme(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_ENERGIEDATEN_WASSER:
                return validateFieldWasser(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_FAHRZEUGE:
                return validateFieldFahrzeuge(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_FAHRZEUGE_JAHRESWERTE:
                return validateFieldFahrzeugeJahreswerte(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_KLIMAGASE:
                return validateFieldKlimagase(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_MASCHINEN:
                return validateFieldMaschinen(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_MASCHINEN_JAHRESWERTE:
                return validateFieldMaschinenJahreswerte(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_OEL_ABRECHNUNG:
                return validateFieldOelabrechnung(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_SONSTIGE_DATEN:
                return validateFieldSonstigeDaten(key, value, data, onValueChange);
            case IDs.ENT_STANDORT:
                return validateFieldStandort(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_UNTERNEHMENSDATEN:
                return validateFieldUnternehmensdaten(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_VSME_BPM3:
                return validateFieldVsmeBpm3(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_VSME_BPM3_SCOPE1:
                return validateFieldVsmeBpm3Scope1(key, value, data, onValueChange, dataGlobal, callback);
            case IDs.ENT_VSME_BPM3_SCOPE2:
                return validateFieldVsmeBpm3Scope2(key, value, data, onValueChange, dataGlobal, callback);
        }
    };

    let validMsg: string = getValidMsg();
    if (errorType === 'warning') {
        validMsg = setErrorLevelAddOn(validMsg, ErrorLevel.warning);
    } else if (errorType === 'error') {
        validMsg = setErrorLevelAddOn(validMsg, ErrorLevel.error);
    }
    return validMsg;
}

function checkAbrechnungsmodusMonat(value: number, data: any, entity: string, dataGlobal: any, callback: (data: any) => void): string {
    const values: any = data.values || {};

    if (values.jahr !== Moment().year() && !values.parent_tid && value === 2 /*{2} Monatsrechnungen*/) {
        const invalidMonate: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; // Array.from(Array(13).keys()).slice(1)
        ((dataGlobal || {})[entity] || []).forEach((item: any) => {
            const monat: number = item.monat || null;
            if (item.parent_tid === values.tid && item.monat >= 1 && item.monat <= 12) {
                if ([IDs.ENT_ENERGIEDATEN_STROM, IDs.ENT_ENERGIEDATEN_WAERME].indexOf(entity) !== -1) {
                    item = { ...item, abrechnungsart: values.abrechnungsart };
                }
                if (isValid(item, entity, dataGlobal)) {
                    delete invalidMonate[monat - 1];
                }
            }
        });
        if (!!invalidMonate.reduce((a: number, b: number) => a + b, 0)) {
            processCallback(callback, { type: 'error' });
            return 'Solange im Monats-Rechner nicht alle Monatsfelder korrekt eingegeben wurden, kann der Datensatz für dieses Jahr in der Auswertung nicht berücksichtigt werden.';
        }
    }
    return null;
}

function checkAbwaerme(
    key: string, value: string, onValueChange: (name: string, value: any) => void, callback: (data: any) => void
): string {
    const errMin = getPlausiValue('abwaermetemperatur.error.min', 20);
    const errMax = getPlausiValue('abwaermetemperatur.error.max', 9999);
    const warMax = getPlausiValue('abwaermetemperatur.warning.max', 500);
    if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
        processCallback(callback, { type: 'error' });
        return `Die Abwärmetemperatur muss im Bereich [${errMin} - ${errMax}] liegen`;
    }
    if (+value > warMax && +value <= errMax) {
        processCallback(callback, { type: 'warning' });
        return 'Die eingetragene Abwärmetemperatur ist ungewöhnlich hoch. Bitte überprüfen Sie die Dateneingabe nocheinmal.';
    }
    return null;
}

function checkAnschaffungsjahr(
    key: string, value: string, data: any, onValueChange: (name: string, value: any) => void, callback: (data: any) => void
): string {
    const errMin = getPlausiValue('anschaffungsjahr.error.min', 1960);
    const warMax = getPlausiValue('anschaffungsjahr.warning.max', 1990);
    const values: any = data.values || {};
    const baujahr: number = isNaN(+values.baujahr) ? null : +values.baujahr;
    const min: number = baujahr && baujahr > errMin && +baujahr <= Moment().year() ? baujahr : errMin;
    // console.log('Check Anschaffungsjahr: ', min, +value, data);
    if (!isSomeKindOfNumber(value) || +value < min || +value > Moment().year()) {
        processCallback(callback, { type: 'error' });
        return `Das Anschaffungsjahr muss im Bereich [${min} - ${Moment().year()}] liegen`;
    }
    if (+value >= errMin && +value <= warMax) {
        processCallback(callback, { type: 'warning' });
        return 'Bei diesem Anschaffungsjahr wäre das Fahrzeug vergleichsweise alt. Bitte überprüfen Sie die Dateneingabe nocheinmal.';
    }
    return null;
}

function checkAnschlussleistung(
    key: string, value: string, onValueChange: (name: string, value: any) => void, callback: (data: any) => void
): string {
    const errMin = getPlausiValue('anschlussleistung.error.min', 0.01);
    const errMax = getPlausiValue('anschlussleistung.error.max', 9999);
    const warMax = getPlausiValue('anschlussleistung.warning.max', 500);
    if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
        processCallback(callback, { type: 'error' });
        return `Die Leistung muss im Bereich [${errMin} - ${errMax}] liegen`;
    }
    if (+value > warMax && +value <= errMax) {
        processCallback(callback, { type: 'warning' });
        return 'Die eingetragene Anschlussleistung ist ungewöhnlich hoch. Bitte überprüfen Sie die Dateneingabe nocheinmal.';
    }
    return null;
}

export function checkAZ(
    key: string, jahr: number, abrechnungszeitraum_von: number, abrechnungszeitraum_bis: number, dataGlobal?: any, callback?: (data: any) => void
): string {
    const minVon = Moment(`01-07-${+jahr - 1}`, 'DD-MM-YYYY').unix();
    const maxVon = Moment(`01-01-${+jahr + 1}`, 'DD-MM-YYYY').unix();
    const minBis = Moment(`01-01-${jahr}`, 'DD-MM-YYYY').unix();
    const maxBis = Moment(`01-07-${+jahr + 1}`, 'DD-MM-YYYY').unix();
    const modul: string = dataGlobal ? dataGlobal.MODUL_SELECTED : undefined;
    switch (key) {
        case 'abrechnungszeitraum_bis':
            if (
                jahr && abrechnungszeitraum_bis !== -1
                && (+jahr !== +Moment(abrechnungszeitraum_bis, 'X').year()
                    && (abrechnungszeitraum_bis > maxBis || abrechnungszeitraum_bis < minBis))
            ) {
                processCallback(callback, { type: 'error' });
                return `Datum muss in ${jahr} oder vor dem 01.07.${+jahr + 1} liegen`;
            }

            if (modul === 'steuer') {
                if (isAZbnej(jahr, undefined, abrechnungszeitraum_bis)) {
                    processCallback(callback, { inputOnly: true, type: 'warning' });
                    return sysTxtSteuerAZNichtEinJahr;
                }
            } else {
                if (isAZrma1MiFj(jahr, abrechnungszeitraum_bis)) {
                    processCallback(callback, { inputOnly: true, type: 'warning' });
                    return `${sysTxtAZMehrAlsEinMonat} Folgejahr`;
                }
            }

            break;
        case 'abrechnungszeitraum_von':
            if (
                jahr && abrechnungszeitraum_von !== -1
                && (+jahr !== + Moment(abrechnungszeitraum_von, 'X').year()
                    && (abrechnungszeitraum_von > maxVon || abrechnungszeitraum_von < minVon))
            ) {
                processCallback(callback, { type: 'error' });
                return `Datum muss in ${jahr} oder nach dem 30.06.${jahr - 1} liegen`;
            }

            if (modul === 'steuer') {
                if (isAZbnej(jahr, abrechnungszeitraum_von, undefined)) {
                    processCallback(callback, { inputOnly: true, type: 'warning' });
                    return sysTxtSteuerAZNichtEinJahr;
                }
            } else {
                if (isAZrma1MiVj(jahr, abrechnungszeitraum_von)) {
                    processCallback(callback, { inputOnly: true, type: 'warning' });
                    return `${sysTxtAZMehrAlsEinMonat} Vorjahr`;
                }
            }

            if (+abrechnungszeitraum_von > +abrechnungszeitraum_bis) {
                processCallback(callback, { type: 'error' });
                return 'Abrechnungszeitraum (von) > Abrechnungszeitraum (bis)';
            }

            break;
    }
    return null;
}

function checkAZOverlap(entity: string, values: any, dataGlobal: any) {
    const standort_tid = +values.standort_tid_orig || +values.standort_tid;
    let filtered = (dataGlobal[entity] || []).filter((r: any) =>
        r.tid !== values.tid && r.standort_tid_orig === standort_tid && r.jahr === values.jahr &&
        !(
            (values.abrechnungszeitraum_von >= r.abrechnungszeitraum_bis && values.abrechnungszeitraum_bis > r.abrechnungszeitraum_bis) ||
            (values.abrechnungszeitraum_von < r.abrechnungszeitraum_von && values.abrechnungszeitraum_bis <= r.abrechnungszeitraum_von)
        )
    );
    switch (entity) {
        case IDs.ENT_ENERGIEDATEN_EIGENSTROM:
            const anlagen_eigenstrom_typ_tid = +values.anlagen_eigenstrom_typ_tid_orig || +values.anlagen_eigenstrom_typ_tid;
            filtered = filtered.filter((r: any) => r.anlagen_eigenstrom_typ_tid_orig === anlagen_eigenstrom_typ_tid);
    }
    if (filtered.length > 0) {
        // console.log(values, filtered);
        const d = filtered[0];
        return `Der eingegebene Zeitraum überschneidet sich mit einem bereits vorhandenen Zeitraum (${Moment.unix(d.abrechnungszeitraum_von).format('DD.MM.YYYY')} - ${Moment.unix(d.abrechnungszeitraum_bis).format('DD.MM.YYYY')}).`;
    }
    return null;
}

function checkCO2Scope3RaeumlichkeitenFlaeche(data: any, callback: (data: any) => void): string {
    const values: any = data.values || {};
    const flaeche: number = isSomeKindOfNumber(values.flaeche) ? +values.flaeche : null;
    const flaeche_gesamt: number = isSomeKindOfNumber(values.flaeche_gesamt) ? +values.flaeche_gesamt : null;
    if (flaeche !== null && flaeche_gesamt !== null && flaeche > flaeche_gesamt) {
        const float: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true });
        processCallback(callback, { type: 'error' });
        return `Die Fläche [m²] darf nicht größer als ${float.format(flaeche_gesamt)} sein.`;
    }
    return null;
}

function checkEmail(value: string, callback: (data: any) => void): string {
    if (value || null) {
        const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!regex.test(String(value).toLowerCase())) {
            processCallback(callback, { type: 'error' });
            return 'Keine gültige E-Mail-Adresse';
        }
    }
    return null;
}

function checkEnergiekostenanteilUmsatz(data: any, dataGlobal: any, callback: (data: any) => void): string {
    dataGlobal = dataGlobal || {};
    const values: any = data.values || {};
    const jahr: number = isSomeKindOfNumber(values.jahr) ? +values.jahr : null;
    const standort_tid: number = isSomeKindOfNumber(values.standort_tid) ? +values.standort_tid : 0;
    const umsatz: number = isSomeKindOfNumber(values.umsatz) ? +values.umsatz : 0;
    const kennzahlen: any = (dataGlobal[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort_tid]
        || dataGlobal[IDs.KENNZIFFERN_BERECHNET] || {};
    const strom_kosten: number = kennzahlen[jahr] && kennzahlen[jahr].strom_kosten_gesamt ? kennzahlen[jahr].strom_kosten_gesamt : 0;
    const waerme_kosten: number = kennzahlen[jahr] && kennzahlen[jahr].kosten_waerme ? kennzahlen[jahr].kosten_waerme : 0;
    const kraftstoffe_kosten: number = kennzahlen[jahr] && kennzahlen[jahr].kraftstoffe_kosten ? kennzahlen[jahr].kraftstoffe_kosten : 0;
    const kosten_gesamt: number = strom_kosten + waerme_kosten + kraftstoffe_kosten;
    const umsatz_anteil: number = umsatz > 0 ? ((100 / umsatz) * kosten_gesamt) : 0;
    const errMax = getPlausiValue('betriebsdaten.energiekostenanteil_umsatz.error.max', 50);
    const warMax = getPlausiValue('betriebsdaten.energiekostenanteil_umsatz.warning.max', 15);
    if (umsatz_anteil >= errMax) {
        processCallback(callback, { type: 'error' });
        return `Der Energiekostenanteil am Umsatz [${formatFloat.format(umsatz_anteil)}%] muss unter [${errMax}%] liegen.`;
    } else if (umsatz_anteil >= warMax) {
        processCallback(callback, { type: 'warning' });
        return `Der Energiekostenanteil am Umsatz [${formatFloat2.format(umsatz_anteil)}%] ist ungewöhnlich hoch. Bitte überprüfen Sie die Dateneingabe nocheinmal.`;
    }
    processCallback(callback, null);
    return null;
}

function checkFremdbezug(data: any, dataGlobal: any, callback: (data: any) => void): string {
    const values: any = data.values || {};
    const einheit: string = ((data.getBundleValues('einheit_tid') || [])
        .find((item: any) => item.tid === values.einheit_tid) || {}).name || values.einheit_tid_name || null;
    const fremdbezug: number = isSomeKindOfNumber(values.fremdbezug) ? +values.fremdbezug : null;
    // console.log('Check Fremdbezug', einheit, values, data.getBundleValues('einheit_tid'));
    const errMin = getPlausiValue('fremdbezug.m3.error.min', 0);
    const errMax = getPlausiValue('fremdbezug.m3.error.max', 9999);
    const err2Min = getPlausiValue('fremdbezug.error.min', 0);
    const err2Max = getPlausiValue('fremdbezug.error.max', 9999999);
    if (einheit === 'm³' && fremdbezug !== null && (+fremdbezug < errMin || +fremdbezug > errMax)) {
        processCallback(callback, { type: 'error' });
        return `Der Fremdbezug muss im Bereich [${errMin} - ${errMax}] liegen`;
    } else if (fremdbezug !== null && (+fremdbezug < err2Min || +fremdbezug > err2Max)) {
        processCallback(callback, { type: 'error' });
        return `Der Fremdbezug muss im Bereich [${err2Min} - ${err2Max}] liegen`;
    }
    processCallback(callback, null);
    return null;
}

function checkHausnummer(key: string, value: string, onValueChange: (name: string, value: any) => void): string {
    if (value || null) {
        const newValue: string = value.replace(/[^0-9 a-zA-Z-/&]/g, '');
        if (newValue !== value) {
            onValueChange(key, newValue);
        }
    }
    return null;
}

function checkFahrzeugbaujahr(
    key: string, value: string, onValueChange: (name: string, value: any) => void, callback: (data: any) => void
): string {
    const errMin = getPlausiValue('fahrzeugbaujahr.error.min', 1960);
    const warMax = getPlausiValue('fahrzeugbaujahr.warning.max', 1990);
    if (isSomeKindOfNumber(value) && (!Number.isInteger(value) || +value < errMin || +value > Moment().year())) {
        processCallback(callback, { type: 'error' });
        return `Das Baujahr muss im Bereich [${errMin} - ${Moment().year()}] liegen`;
    }
    if (+value >= errMin && +value <= warMax) {
        processCallback(callback, { type: 'warning' });
        return 'Bei diesem Baujahr wäre das Fahrzeug vergleichsweise alt. Bitte überprüfen Sie die Dateneingabe nocheinmal.';
    }
    return null;
}

function checkFahrzeugJahreslaufleistung(
    key: string, value: string, data: any, onValueChange: (name: string, value: any) => void, callback: (data: any) => void
): string {
    const errMin = getPlausiValue('fahrzeugJahreslaufleistung.error.min', 0);
    const errMax = getPlausiValue('fahrzeugJahreslaufleistung.error.max', 99999);
    const warMax = getPlausiValue('fahrzeugJahreslaufleistung.warning.max', 50000);
    if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
        processCallback(callback, { type: 'error' });
        return `Die Jahreslaufleistung [km] muss im Bereich [${errMin} - ${errMax}] liegen`;
    }
    if (+value > warMax && +value <= errMax) {
        processCallback(callback, { type: 'warning' });
        return 'Die Jahreslaufleistung ist ungewöhnlich hoch. Bitte überprüfen Sie die Dateneingabe nocheinmal.';
    }
    return null;
}

function checkFahrzeugJahrStatus(
    key: string, value: string, data: any, onValueChange: (name: string, value: any) => void, callback: (data: any) => void
): string {
    const values: any = data.values || {};
    const status: number = isSomeKindOfNumber(values.status) ? +values.status : null;
    const anschaffungsjahr: number = isSomeKindOfNumber(values.anschaffungsjahr) ? +values.anschaffungsjahr : null;
    if (status === 2 && isSomeKindOfNumber(value) && (!Number.isInteger(value) || +value < anschaffungsjahr || +value > Moment().year())) {
        processCallback(callback, { type: 'error' });
        return `Das Jahr (verkauft/verschrottet) muss im Bereich [${anschaffungsjahr} - ${Moment().year()}] liegen`;
    }
    return null;
}

function checkFahrzeugleistung(
    key: string, value: string, data: any, onValueChange: (name: string, value: any) => void, callback: (data: any) => void
): string {
    const errMin = getPlausiValue('fahrzeugleistung.error.min', 0);
    const errMax = getPlausiValue('fahrzeugleistung.error.max', 999);
    const warMax = getPlausiValue('fahrzeugleistung.warning.max', 300);
    if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
        processCallback(callback, { type: 'error' });
        return `Die Leistung muss im Bereich [${errMin} - ${errMax}] liegen`;
    }
    if (+value > warMax && +value <= errMax) {
        processCallback(callback, { type: 'warning' });
        return 'Die Fahrzeug-Leistung ist ungewöhnlich hoch. Bitte überprüfen Sie die Dateneingabe nocheinmal.';
    }
    return null;
}

function checkPlz(key: string, value: string, onValueChange: (name: string, value: any) => void, callback: (data: any) => void): string {

    let len_plz = 5;
    if(config.orte_file == 'orte_lux.json'){ // Dirty
        len_plz = 4;
    }

    if (value || null) {
        const newValue: string = value.replace(/[^0-9]/g, '').substr(0, len_plz);
        if (newValue !== value && typeof onValueChange === 'function') {
            onValueChange(key, newValue);
        }
    }
    if (value && (value || '').toString().length < len_plz) {
        processCallback(callback, { type: 'error' });
        return 'mind. ' + len_plz + ' Zahlen';
    }
    if (value && !getOrt(value)) {
        processCallback(callback, { type: 'error' });
        return 'Keine gültige Postleitzahl';
    }
    return null;
}

function checkKennzahl(key: string, data: any, dataGlobal: any, callback: (data: any) => void, prefix?: string): string {
    const values: any = data || {};
    const jahr: number = +values.jahr || null;
    let message: string = null;
    isValidKennzahl(key, values, dataGlobal, (result: any) => {
        if (jahr > +result.jahr && (result.isGreater || result.isLess)) {
            const compare: string[] = (result.compare || []).map((value: number) => formatFloat.format(value));
            const percent: string = typeof result.percent === 'number' ? `${formatFloat2.format(result.percent)}%` : '';
            processCallback(callback, result.isValid ? { category: 'compare_prev', type: 'warning' } : { type: 'error' });
            message = `${prefix ? prefix : ''}[${compare.join(':')}] ${percent}`;
            // message = `${prefix ? prefix : ''}Die Abweichung [${compare.join(':')}] ${percent} zum` +
            //     ` ${jahr > +result.jahr ? 'Vorjahr' : 'Folgejahr'} ist ${result.isValid ? 'ungewöhnlich hoch' : 'unplausibel'}.`;
        }
    });
    return message;
}

function checkKlimagasmenge(
    key: string, value: string, data: any, onValueChange: (name: string, value: any) => void, callback: (data: any) => void
): string {
    const errMin = getPlausiValue('klimagasmenge.error.min', 0);
    const errMax = getPlausiValue('klimagasmenge.error.max', 9999);
    const warMax = getPlausiValue('klimagasmenge.warning.max', 50);
    if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
        processCallback(callback, { type: 'error' });
        return `Die Menge [kg] muss im Bereich [${errMin} - ${errMax}] liegen`;
    }
    if (+value > warMax && +value <= 9999) {
        processCallback(callback, { type: 'warning' });
        return `Die Menge ${fn2nZ(value)} [kg] ist ungewöhnlich hoch. Bitte überprüfen Sie Ihre Eingabe.`;
    }
    return null;
}

function checkKraftstoffJahreslaufleistung(
    key: string, value: string, data: any, onValueChange: (name: string, value: any) => void, callback: (data: any) => void
): string {
    const values: any = data.values || {};
    const fahrzeug_tid: number = isSomeKindOfNumber(values.fahrzeug_tid) ? +values.fahrzeug_tid : null;
    const errMin = getPlausiValue('kraftstoffJahreslaufleistung.error.min', 0);
    const errMax = getPlausiValue('kraftstoffJahreslaufleistung.error.max', 99999);
    const warMax = getPlausiValue('kraftstoffJahreslaufleistung.warning.max', 50000);
    if (fahrzeug_tid !== null && fahrzeug_tid > 0 && isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
        processCallback(callback, { type: 'error' });
        return `Die Jahreslaufleistung [km] muss im Bereich [${errMin} - ${errMax}] liegen`;
    }
    if (fahrzeug_tid !== null && fahrzeug_tid > 0 && +value > warMax && +value <= errMax) {
        processCallback(callback, { type: 'warning' });
        return 'Die Jahreslaufleistung ist ungewöhnlich hoch. Bitte überprüfen Sie die Dateneingabe nocheinmal.';
    }
    return null;
}

function checkKraftstoffpreis(data: any, callback: (data: any) => void): string {
    const values: any = data.values || {};
    const energietraeger: string = ((data.getBundleValues('energietraeger_tid') || [])
        .find((item: any) => item.tid === values.energietraeger_tid) || {}).name || values.energietraeger_tid_name || null;
    const kosten: number = isSomeKindOfNumber(values.kosten) ? +values.kosten : null;
    const verbrauch: number = isSomeKindOfNumber(values.verbrauch) ? +values.verbrauch : null;
    const preis: number = kosten !== null && verbrauch !== null && verbrauch > 0 ? +(kosten / verbrauch).toFixed(3) : null;
    const getString = (name: string, einheit?: string, limits?: number[]): string => {
        name = name === 'LPG' ? `${name}-Preis` : `${name}preis`;
        if ((limits || []).length !== 4) {
            return null;
        }
        switch (true) {
            case (preis < limits[0]):
                processCallback(callback, { type: 'error' });
                return `${name} < ${fn2nZ(limits[0])} [€/${einheit}]`;
            case (preis >= limits[0] && preis < limits[1]):
                processCallback(callback, { type: 'warning' });
                return `Der ${name} ${fn2nZ(preis)} [€/${einheit}] ist ungewöhnlich niedrig. Bitte überprüfen Sie Ihre Eingabe.`;
            case (preis > limits[2] && preis <= limits[3]):
                processCallback(callback, { type: 'warning' });
                return `Der ${name} ${fn2nZ(preis)} [€/${einheit}] ist ungewöhnlich hoch. Bitte überprüfen Sie Ihre Eingabe.`;
            case (preis > limits[3]):
                processCallback(callback, { type: 'error' });
                return `${name} > ${fn2nZ(limits[3])} [€/${einheit}]`;
        }
        return null;
    };
    if (preis !== null && preis >= 0) {
        switch (energietraeger) {
            case 'Benzin [Liter]':
                return getString('Benzin', 'l', [
                    getPlausiValue('kraftstoffpreis.benzin.error.min', 0.9),
                    getPlausiValue('kraftstoffpreis.benzin.warning.min', 1.2),
                    getPlausiValue('kraftstoffpreis.benzin.warning.max', 2.5),
                    getPlausiValue('kraftstoffpreis.benzin.error.max', 2.9)
                ]);
            case 'Diesel [Liter]':
                return getString('Diesel', 'l', [
                    getPlausiValue('kraftstoffpreis.diesel.error.min', 0.6),
                    getPlausiValue('kraftstoffpreis.diesel.warning.min', 0.8),
                    getPlausiValue('kraftstoffpreis.diesel.warning.max', 2.5),
                    getPlausiValue('kraftstoffpreis.diesel.error.max', 2.9)
                ]);
            case 'Biodiesel [Liter]': return null;
                return getString('Biodiesel', 'l', [
                    getPlausiValue('kraftstoffpreis.biodiesel.error.min', 0.6),
                    getPlausiValue('kraftstoffpreis.biodiesel.warning.min', 0.8),
                    getPlausiValue('kraftstoffpreis.biodiesel.warning.max', 2.5),
                    getPlausiValue('kraftstoffpreis.biodiesel.error.max', 2.9)
                ]);
            case 'Bioethanol [Liter]': return null;
                return getString('Bioethanol', 'l', [
                    getPlausiValue('kraftstoffpreis.bioethanol.error.min', 0.6),
                    getPlausiValue('kraftstoffpreis.bioethanol.warning.min', 0.8),
                    getPlausiValue('kraftstoffpreis.bioethanol.warning.max', 2.5),
                    getPlausiValue('kraftstoffpreis.bioethanol.error.max', 2.9)
                ]);
            case 'Erdgas [kg]':
                return getString('Gas', 'kg', [
                    getPlausiValue('kraftstoffpreis.erdgas.error.min', 0.7),
                    getPlausiValue('kraftstoffpreis.erdgas.warning.min', 0.9),
                    getPlausiValue('kraftstoffpreis.erdgas.warning.max', 1.4),
                    getPlausiValue('kraftstoffpreis.erdgas.error.max', 1.8)
                ]);
            case 'Ladestrom [kWh]':
                return getString('Strom', 'kWh', [
                    getPlausiValue('kraftstoffpreis.ladestrom.error.min', 0.05),
                    getPlausiValue('kraftstoffpreis.ladestrom.warning.min', 0.12),
                    getPlausiValue('kraftstoffpreis.ladestrom.warning.max', 0.8),
                    getPlausiValue('kraftstoffpreis.ladestrom.error.max', 1.2)
                ]);
            case 'LPG [Liter]':
                return getString('LPG', 'l', [
                    getPlausiValue('kraftstoffpreis.lpg.error.min', 0.2),
                    getPlausiValue('kraftstoffpreis.lpg.warning.min', 0.4),
                    getPlausiValue('kraftstoffpreis.lpg.warning.max', 1.15),
                    getPlausiValue('kraftstoffpreis.lpg.error.max', 1.45)
                ]);
            case 'Wasserstoff [kg]':
                return getString('Wasserstoff', 'kg', [
                    getPlausiValue('kraftstoffpreis.wasserstoff.error.min', 6),
                    getPlausiValue('kraftstoffpreis.wasserstoff.warning.min', 8),
                    getPlausiValue('kraftstoffpreis.wasserstoff.warning.max', 11),
                    getPlausiValue('kraftstoffpreis.wasserstoff.error.max', 15)
                ]);
            default:
                return getString('Kraftstoff');
        }
    } else if (kosten !== null && verbrauch !== null && verbrauch === 0) {
        processCallback(callback, { type: 'warning' });
        return 'Preisberechnung. "Division durch 0"';
    }
    processCallback(callback, null);
    return null;
}

function checkMaschineJahrStatus(
    key: string, value: string, data: any, onValueChange: (name: string, value: any) => void, callback: (data: any) => void
): string {
    const values: any = data.values || {};
    const status: number = isSomeKindOfNumber(values.status) ? +values.status : null;
    const baujahr: number = isSomeKindOfNumber(values.baujahr) ? +values.baujahr : null;
    if (status === 2 && isSomeKindOfNumber(value) && (!Number.isInteger(value) || +value < baujahr || +value > Moment().year())) {
        processCallback(callback, { type: 'error' });
        return `Das Jahr (verkauft/verschrottet) muss im Bereich [${baujahr} - ${Moment().year()}] liegen`;
    }
    return null;
}

function checkMaschinenbaujahr(
    key: string, value: string, onValueChange: (name: string, value: any) => void, callback: (data: any) => void
): string {
    const errMin = getPlausiValue('maschinenbaujahr.error.min', 1900);
    const warMax = getPlausiValue('maschinenbaujahr.warning.max', 1960);
    if (isSomeKindOfNumber(value) && (!Number.isInteger(value) || +value < errMin || +value > Moment().year())) {
        processCallback(callback, { type: 'error' });
        return `Das Baujahr muss im Bereich [${errMin} - ${Moment().year()}] liegen`;
    }
    if (+value >= errMin && +value <= warMax) {
        processCallback(callback, { type: 'warning' });
        return 'Bei diesem Baujahr ist die Maschine / Anlage vergleichsweise alt. Bitte überprüfen Sie die Dateneingabe nocheinmal.';
    }
    return null;
}

function checkRaeumlichkeitenFlaecheGebaude(data: any, callback: (data: any) => void): string {
    const values: any = data.values || {};
    const flaeche: number = isSomeKindOfNumber(values.flaeche) ? +values.flaeche : null;
    const flaeche_gebaeude: number = isSomeKindOfNumber(values.flaeche_gebaeude) ? +values.flaeche_gebaeude : null;
    if (flaeche !== null && flaeche_gebaeude !== null && flaeche_gebaeude < flaeche) {
        const float: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true });
        processCallback(callback, { type: 'error' });
        return `Die Gebäudeenergiebezugsfläche [m²] darf nicht kleiner als ${float.format(flaeche)} sein.`;
    }
    return null;
}

function checkRegenBrunnennutzung(data: any, dataGlobal: any, callback: (data: any) => void): string {
    const values: any = data.values || {};
    const einheit: string = ((data.getBundleValues('einheit_regen_tid') || [])
        .find((item: any) => item.tid === values.einheit_regen_tid) || {}).name || values.einheit_regen_tid_name || null;
    const regen_brunnennutzung: number = isSomeKindOfNumber(values.regen_brunnennutzung) ? +values.regen_brunnennutzung : null;
    const errMin = getPlausiValue('regenBrunnennutzung.m3.error.min', 0);
    const errMax = getPlausiValue('regenBrunnennutzung.m3.error.max', 9999);
    const err2Min = getPlausiValue('regenBrunnennutzung.error.min', 0);
    const err2Max = getPlausiValue('regenBrunnennutzung.error.max', 9999999);
    if (einheit === 'm³' && regen_brunnennutzung !== null && (+regen_brunnennutzung < errMin || +regen_brunnennutzung > errMax)) {
        processCallback(callback, { type: 'error' });
        return `Die Regen-/Brunnennutzung muss im Bereich [${errMin} - ${errMax}] liegen`;
    } else if (regen_brunnennutzung !== null && (+regen_brunnennutzung < err2Min || +regen_brunnennutzung > err2Max)) {
        processCallback(callback, { type: 'error' });
        return `Die Regen-/Brunnennutzung muss im Bereich [${err2Min} - ${err2Max}] liegen`;
    }
    processCallback(callback, null);
    return null;
}

function checkStromEinspeiseverguetung(data: any, callback: (data: any) => void): string {
    const values: any = data.values || {};
    const einspeiseverguetung: number = isSomeKindOfNumber(values.einspeiseverguetung) ? +values.einspeiseverguetung : null;
    const netzeinspeisung_kwh: number = isSomeKindOfNumber(values.netzeinspeisung_kwh) ? +values.netzeinspeisung_kwh : null;
    const compare: number = einspeiseverguetung !== null && netzeinspeisung_kwh !== null && netzeinspeisung_kwh > 0
        ? +(einspeiseverguetung / netzeinspeisung_kwh).toFixed(2)
        : null;
    const errMin = getPlausiValue('stromEinspeiseverguetung.error.min', 0.01);
    const errMax = getPlausiValue('stromEinspeiseverguetung.error.max', 0.63);
    if (compare !== null && compare >= 0) {
        if (compare < errMin) {
            processCallback(callback, { type: 'error' });
            return `Netzeinspeisung / Einspeisevergütung < ${fn2nZ(errMin)} [€/kWh]`;
        }
        if (compare > errMax) {
            processCallback(callback, { type: 'error' });
            return `Netzeinspeisung / Einspeisevergütung > ${fn2nZ(errMax)} [€/kWh]`;
        }
    }
    return null;
}

function checkStromNetzeinspeisung(data: any, callback: (data: any) => void): string {
    const values: any = data.values || {};
    const gesamtproduktion_kwh: number = isSomeKindOfNumber(values.gesamtproduktion_kwh) ? +values.gesamtproduktion_kwh : null;
    const netzeinspeisung_kwh: number = isSomeKindOfNumber(values.netzeinspeisung_kwh) ? +values.netzeinspeisung_kwh : null;
    if (gesamtproduktion_kwh !== null && netzeinspeisung_kwh !== null && netzeinspeisung_kwh > gesamtproduktion_kwh) {
        const float: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true });
        processCallback(callback, { type: 'error' });
        return `Die Netzeinspeisung [kWh] darf nicht größer als ${float.format(gesamtproduktion_kwh)} sein.`;
    }
    return null;
}

function checkStrompreis(data: any, callback: (data: any) => void): string {
    const values: any = data.values || {};
    const abrechnungsart: number = isSomeKindOfNumber(values.abrechnungsart) ? +values.abrechnungsart : null; // {1} Reguläre Abrechnung, {2} Einzelabrechnung, {3} Erste Abrechnung, {4} Letzte Abrechnung
    const kosten: number = isSomeKindOfNumber(values.kosten_netto) ? +values.kosten_netto : null;
    const verbrauch: number = isSomeKindOfNumber(values.verbrauch_kwh) ? +values.verbrauch_kwh : null;
    const preis: number = kosten !== null && verbrauch !== null && verbrauch > 0 ? +(kosten / verbrauch).toFixed(2) : null;
    const limit1 = getPlausiValue('strompreis.error.min', 0.05);
    const limit2 = getPlausiValue('strompreis.warning.min', 0.12);
    const limit3 = getPlausiValue('strompreis.warning.max', 0.8);
    const limit4 = getPlausiValue('strompreis.error.max', 1.2);
    if (abrechnungsart !== 2 && preis !== null && preis >= 0) {
        if (preis < limit1) {
            processCallback(callback, { type: 'error' });
            return `Strompreis < ${fn2nZ(limit1)} [€/kWh]`;
        }
        if (preis >= limit1 && preis < limit2) {
            processCallback(callback, { type: 'warning' });
            return `Der Strompreis ${fn2nZ(preis)} [€/kWh] ist ungewöhnlich niedrig. Bitte überprüfen Sie Ihre Eingabe.`;
        }
        if (preis > limit3 && preis <= limit4) {
            processCallback(callback, { type: 'warning' });
            return `Der Strompreis ${fn2nZ(preis)} [€/kWh] ist ungewöhnlich hoch. Bitte überprüfen Sie Ihre Eingabe.`;
        }
        if (preis > limit4) {
            processCallback(callback, { type: 'error' });
            return `Strompreis > ${fn2nZ(limit4)} [€/kWh]`;
        }
    } else if (abrechnungsart !== 2 && kosten !== null && verbrauch !== null && verbrauch === 0) {
        processCallback(callback, { type: 'warning' });
        return 'Preisberechnung. "Division durch 0"';
    }
    processCallback(callback, null);
    return null;
}

function checkStromspitzenlast(data: any, callback: (data: any) => void): string {
    const values: any = data.values || {};
    const spitzenlast: number = isSomeKindOfNumber(values.spitzenlast) ? +values.spitzenlast : null;
    const verbrauch: number = isSomeKindOfNumber(values.verbrauch_kwh) ? +values.verbrauch_kwh : null;
    const stunden: number = spitzenlast !== null && verbrauch !== null && spitzenlast > 0 ? +(verbrauch / spitzenlast).toFixed() : null;
    const errLastMin = getPlausiValue('stromspitzenlast.error.min', 0);
    const errLastMax = getPlausiValue('stromspitzenlast.error.max', 9999);
    const warStunMax = getPlausiValue('stromspitzenlast.stunden.warning.max', 8760);
    if (spitzenlast !== null && (+spitzenlast < errLastMin || +spitzenlast > errLastMax)) {
        processCallback(callback, { type: 'error' });
        return `Die Spitzenlast [kW] muss im Bereich [${errLastMin} - ${errLastMax}] liegen`;
    }
    if (stunden !== null && stunden >= warStunMax) {
        processCallback(callback, { type: 'warning' });
        return 'Die Spitzenlast ist ungewöhnlich niedrig. Bitte überprüfen Sie den Wert.';
    }
    return null;
}

function checkWaermepreis(data: any, dataGlobal: any, callback: (data: any) => void): string {
    const values: any = data.values || {};
    const abrechnungsart: number = isSomeKindOfNumber(values.abrechnungsart) ? +values.abrechnungsart : null; // {1} Reguläre Abrechnung, {2} Einzelabrechnung, {3} Erste Abrechnung, {4} Letzte Abrechnung
    const energietraeger: string = ((data.getBundleValues('energietraeger_tid') || [])
        .find((item: any) => item.tid === values.energietraeger_tid) || {}).name || values.energietraeger_tid_name || null;
    const einheit: string = ((data.getBundleValues('einheit_tid') || [])
        .find((item: any) => item.tid === values.einheit_tid) || {}).name || values.einheit_tid_name || null;
    let einheit_preis: string = einheit;
    const jahr: number = isSomeKindOfNumber(values.jahr) ? +values.jahr : null;
    const convertValue = (value: number): number => getWaermeKwh(energietraeger, value, einheit, jahr, dataGlobal);
    const kosten: number = isSomeKindOfNumber(values.kosten) ? +values.kosten : null;
    const verbrauch: number = isSomeKindOfNumber(values.verbrauch) // verbrauch, fuellmenge
        ? convertValue(+values.verbrauch)
        : (isSomeKindOfNumber(values.fuellmenge) ? convertValue(+values.fuellmenge) : null);
    const preis: number = kosten !== null && verbrauch !== null && verbrauch > 0 ? +(kosten / verbrauch).toFixed(3) : null;
    const getString = (name: string, limits: number[], param: string): string => {
        if ((limits || []).length !== 4 || !param) {
            return null;
        }
        limits[0] = getPlausiValue(`waermepreis.${param}.error.min`, limits[0]);
        limits[1] = getPlausiValue(`waermepreis.${param}.warning.min`, limits[1]);
        limits[2] = getPlausiValue(`waermepreis.${param}.warning.max`, limits[2]);
        limits[3] = getPlausiValue(`waermepreis.${param}.error.max`, limits[3]);
        switch (true) {
            case (preis < limits[0]):
                processCallback(callback, { type: 'error' });
                return `${name}preis < ${fn2nZ(limits[0])} [€/${einheit_preis}]`;
            case (preis >= limits[0] && preis < limits[1]):
                processCallback(callback, { type: 'warning' });
                return `Der ${name}preis ${fn2nZ(preis)} [€/${einheit_preis}] ist ungewöhnlich niedrig. Bitte überprüfen Sie Ihre Eingabe.`;
            case (preis > limits[2] && preis <= limits[3]):
                processCallback(callback, { type: 'warning' });
                return `Der ${name}preis ${fn2nZ(preis)} [€/${einheit_preis}] ist ungewöhnlich hoch. Bitte überprüfen Sie Ihre Eingabe.`;
            case (preis > limits[3]):
                processCallback(callback, { type: 'error' });
                return `${name}preis > ${fn2nZ(limits[3])} [€/${einheit_preis}]`;
        }
        processCallback(callback, null);
        return null;
    };
    if (abrechnungsart !== 2 && preis !== null && preis >= 0) {
        switch (energietraeger) {
            case 'Biogas': break;
                einheit_preis = 'kWh';
                return ['kg', 'kWh', 'm³'].indexOf(einheit) !== -1 ? getString(energietraeger, [-1, -1, -1, -1], 'biogas') : null;
            case 'Biomasse - Brennholz': break;
                einheit_preis = 'kWh';
                return ['kWh', 'Rm (Raummeter)'].indexOf(einheit) !== -1 ? getString('Brennholz', [-1, -1, -1, -1], 'bio_brennholz') : null;
            case 'Biomasse - Hackschnitzel': break;
                einheit_preis = 'kWh';
                return ['kWh', 'Srm (Schüttraummeter)'].indexOf(einheit) !== -1 ? getString('Hackschnitzel', [-1, -1, -1, -1], 'bio_hackschnitzel') : null;
            case 'Biomasse - Pellets': break;
                einheit_preis = 'kWh';
                return ['kg', 'kWh'].indexOf(einheit) !== -1 ? getString('Pellet', [-1, -1, -1, -1], 'bio_holzpellets') : null;
            case 'Erdgas':
                einheit_preis = 'kWh';
                return ['kWh', 'm³'].indexOf(einheit) !== -1 ? getString(energietraeger, [0.02, 0.035, 0.25, 0.4], 'erdgas') : null;
            case 'Fernkälte': break;
                return einheit === 'kWh' ? getString(energietraeger, [-1, -1, -1, -1], 'fernkaelte') : null;
            case 'Fernwärme':
                einheit_preis = 'kWh';
                return ['kWh', 'MWh'].indexOf(einheit) !== -1 ? getString(energietraeger, [0.02, 0.04, 0.21, 0.35], 'fernwaerme') : null;
            case 'Flüssiggas':
                einheit_preis = 'kWh';
                return ['kg', 'kWh', 'Liter'].indexOf(einheit) !== -1 ? getString(energietraeger, [0.15, 0.2, 1, 1.5], 'fluessiggas') : null;
            case 'Heizöl':
                einheit_preis = 'kWh';
                return ['kWh', 'Liter'].indexOf(einheit) !== -1 ? getString(energietraeger, [0.2, 0.35, 1.25, 2], 'heizoel') : null;
            case 'Kohle - Braunkohle': break;
                einheit_preis = 'kWh';
                return ['kg', 'kWh'].indexOf(einheit) !== -1 ? getString('Braunkohle', [-1, -1, -1, -1], 'braunkohle') : null;
            case 'Kohle - Steinkohle': break;
                einheit_preis = 'kWh';
                return ['kg', 'kWh'].indexOf(einheit) !== -1 ? getString('Steinkohle', [-1, -1, -1, -1], 'steinkohle') : null;
            case 'Strom':
                return einheit === 'kWh' ? getString(energietraeger, [0.05, 0.12, 0.8, 1.2], 'strom') : null;
        }
    } else if (abrechnungsart !== 2 && kosten !== null && verbrauch !== null && verbrauch === 0) {
        processCallback(callback, { type: 'warning' });
        return 'Preisberechnung. "Division durch 0"';
    }
    processCallback(callback, null);
    return null;
}

function checkZaehlerwert(key: string, data: any, entity: string, dataGlobal: any, callback: (data: any) => void, prefix?: string): string {
    const values: any = data || {};
    const jahr: number = +values.jahr || null;
    let message: string = null;
    isValidZaehlerwert(key, values, entity, dataGlobal, (result: any) => {
        if (jahr > +result.jahr && (result.isGreater || result.isLess)) {
            const compare: string[] = (result.compare || []).map((value: number) => formatFloat.format(value));
            const percent: string = typeof result.percent === 'number' ? `${formatFloat2.format(result.percent)}%` : '';
            processCallback(callback, result.isValid ? { category: 'compare_prev', type: 'warning' } : { type: 'error' });
            message = `${prefix ? prefix : ''}${result.name ? `Zähler (${result.name}) ` : ''}[${compare.join(':')}] ${percent}`;
            // message = `${prefix ? prefix : ''}Die Abweichung [${compare.join(':')}] ${percent} zum` +
            //     ` ${jahr > +data.jahr ? 'Vorjahr' : 'Folgejahr'} ist ${data.isValid ? 'ungewöhnlich hoch' : 'unplausibel'}.`;
        }
    });
    return message;
}

function checkTeilstrecken(values: any): string {
    if (values.teilstrecken === 1 || values.teilstrecken_orig === 1) {
        return 'Bitte geben Sie alle Teilstrecken über den Teilstrecken-Rechner ein!';
    }
    return null;
}

function checkHinRueck(values: any, feld: string): string {
    if (values.teilstrecken === 1 || values.teilstrecken_orig === 1) {
        return 'Bitte geben Sie Ihre Hinfahrt- und Rückfahrt über den Teilstrecken-Rechner ein!';
    } else if (values.hin_rueck === 1 || values.hin_rueck_orig === 1) {
        return `Bitte geben Sie im Feld ${feld} den einfachen Weg an!`;
    }
    return null;
}

function getEigenstromtypKey(data: any): string {
    data = data || {};
    switch (+data.anlagen_eigenstrom_typ_tid_orig || +data.anlagen_eigenstrom_typ_tid) {
        case 1: // 'Windkraft'
            return 'wind';
        case 2: // 'Photovoltaik'
            return 'pv';
        case 3: // 'Kraft-Wärme-Kopplung'
            return 'kwk';
        default:
            return null;
    }
}

function getStandortHauptsitzAnzahl(tid: number, dataGlobal: any): number {
    const standorte: any[] = (dataGlobal || {})[IDs.ENT_STANDORT] || [];
    return (standorte.length
        ? standorte
            .filter((item: any) => (
                item.tid
                && item.standort_typ_tid_orig
                && +item.tid !== tid
                && +item.standort_typ_tid_orig === 1 // Hauptsitz
            ))
        : []
    ).length;
}

function joinMessages(data: string[]): string {
    const messages: string[] = [];
    (data || []).forEach((message: string, index: number) => {
        if (!message) {
            return;
        }
        messages.push(message);
        // const isLastMessage: boolean = !(typeof data[index + 1] !== 'undefined'
        //     && data.slice(index + 1).reduce((a: string, b: string) => (a || '').toString() + (b || '').toString(), '').length);
        // messages.push(`${messages.length || !isLastMessage ? `(${messages.length + 1}) ` : ''}${message}`);
    });
    return messages.join('\n');
}

function limitString(key: string, value: string, length: number, onValueChange: (name: string, value: any) => void): string {
    if (typeof onValueChange === 'function' && (value || null) && value.length > length) {
        onValueChange(key, value.substr(0, length));
    }
    return null;
}

function processCallback(callback: (data: any) => void, data: any) {
    errorType = (data || {}).type || null;
    if (typeof callback === 'function') {
        callback(data);
    }
}

export function validateFieldAngemieteteFahrzeuge(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'entfernung': {
            const errMin: number = getPlausiValue('angemietete_fahrzeuge.entfernung.error.min', 1);
            const errMax: number = getPlausiValue('angemietete_fahrzeuge.entfernung.error.max', 99999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Entfernung [km] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
    }
    return null;
}

export function validateFieldBetriebsdaten(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any,
    callback?: (data: any) => void
): string {
    let errMin, errMax;
    switch (key) {
        case 'beheizte_flaeche':
            errMin = getPlausiValue('betriebsdaten.beheizte_flaeche.error.min', 1);
            errMax = getPlausiValue('betriebsdaten.beheizte_flaeche.error.max', 99999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Fläche [m²] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'anz_mitarbeiter':
        // no break
        case 'anz_mitarbeiter_real':
            errMin = getPlausiValue('betriebsdaten.anz_mitarbeiter_real.error.min', 1);
            errMax = getPlausiValue('betriebsdaten.anz_mitarbeiter_real.error.max', 9999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Mitarbeitendenanzahl muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'umsatz':
            errMin = getPlausiValue('betriebsdaten.umsatz.error.min', 1);
            errMax = getPlausiValue('betriebsdaten.umsatz.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Jahresumsatz [€] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            return checkEnergiekostenanteilUmsatz(data, dataGlobal, callback);
        case 'auslastung':
            errMin = getPlausiValue('betriebsdaten.auslastung.error.min', 1);
            errMax = getPlausiValue('betriebsdaten.auslastung.error.max', 150);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Auslastung [%] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
    }
    return null;
}

export function validateFieldCfmMotivation(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'jahr': {
            dataGlobal = dataGlobal || {};
            const tid: string = (data.values || {}).tid || null;
            const jahre: number[] = (dataGlobal[IDs.ENT_CFM_MOTIVATION] || [])
                .filter((item: any) => item.tid !== tid)
                .map((item: any) => item.jahr);
            const startjahr: number = ((dataGlobal[IDs.ENT_KONFIGURATION] || [])[0] || {}).startjahr_datenerfassung || null;
            const errMin: number = startjahr || 2010;
            const errMax: number = Moment().year() + 1;
            if (isSomeKindOfNumber(value) && jahre.indexOf(value) !== -1) {
                processCallback(callback, { type: 'error' });
                return 'Das Jahr existiert bereits';
            }
            if (isSomeKindOfNumber(value) && (!Number.isInteger(value) || +value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Das Jahr muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
    }
    return null;
}

export function validateFieldCO2Scope3Abfall(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    const kategorie: string = (data.values || {}).kategorie || null;
    switch (key) {
        case 'leerungen': {
            const errMin: number = getPlausiValue('co2scope3.abfall.leerungen.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.abfall.leerungen.error.max', 52);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Leerungen pro Jahr müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.abfall.menge.error.min', 1);
            const errMax: number = getPlausiValue(
                [`co2scope3.abfall.menge.${kategorie}.error.max`, 'co2scope3.abfall.menge.error.max'], 99999999
            );
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Menge [kg] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'volumen_tonne': {
            const errMin: number = getPlausiValue('co2scope3.abfall.volumen_tonne.error.min', 1);
            const errMax: number = getPlausiValue(
                [`co2scope3.abfall.volumen_tonne.${kategorie}.error.max`, 'co2scope3.abfall.volumen_tonne.error.max'], 9999
            );
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Das Volumen der Abfalltonne [l] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'co2_absolut': {
            const errMin: number = getPlausiValue('co2scope3.abfall.co2_absolut.error.min', 0);
            const errMax: number = getPlausiValue(
                [`co2scope3.abfall.co2_absolut.${kategorie}.error.max`, 'co2scope3.abfall.co2_absolut.error.max'], 99999999
            );
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der CO₂-Ausstoß gesamt [kg] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'einheit_nutzer': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.einheit.limitString.max', 12);
            return limitString(key, value, errMax, onValueChange);
        }
    }
    return null;
}

export function validateFieldCO2Scope3AngemieteteSachanlagen(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'name': {
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'einheit': {
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.einheit.limitString.max', 12);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'menge': {
            const einheit: string = (data.values || {}).einheit || null;
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.menge.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Menge${einheit ? ` [${einheit}]` : ''} muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.faktor.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Faktor muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'quelle': {
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.quelle.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
    }
    return null;
}


export function validateFieldCO2Scope3Emittenten(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'name': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'einheit': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.einheit.limitString.max', 12);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'menge': {
            const einheit: string = (data.values || {}).einheit || null;
            const errMin: number = getPlausiValue('co2scope3.emittenten.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.menge.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Menge${einheit ? ` [${einheit}]` : ''} muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.faktor.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Faktor muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'quelle': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.quelle.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
    }
    return null;
}

export function validateFieldCO2Scope3Franchise(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'name': {
            const errMax: number = getPlausiValue('co2scope3.franchise.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'einheit': {
            const errMax: number = getPlausiValue('co2scope3.franchise.einheit.limitString.max', 12);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'menge': {
            const einheit: string = (data.values || {}).einheit || null;
            const errMin: number = getPlausiValue('co2scope3.franchise.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.franchise.menge.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Menge${einheit ? ` [${einheit}]` : ''} muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.franchise.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.franchise.faktor.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Faktor muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'quelle': {
            const errMax: number = getPlausiValue('co2scope3.franchise.quelle.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
    }
    return null;
}

export function validateFieldCO2Scope3GueterEinkauf(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'name': {
            const errMax: number = getPlausiValue('co2scope3.guetereinkauf.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'menge': {
            const einheit: string = (data.values || {}).einheit || 'kg';
            const errMin: number = getPlausiValue('co2scope3.guetereinkauf.menge.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.guetereinkauf.menge.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Menge [${einheit}] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.guetereinkauf.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.guetereinkauf.faktor.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Faktor muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'quelle': {
            const errMax: number = getPlausiValue('co2scope3.guetereinkauf.quelle.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
    }
    return null;
}

export function validateFieldCO2Scope3GueterKapital(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'art_tid': {
            const values: any = data.values || {};
            const art: string = ((data.getBundleValues('art_tid') || [])
                .find((item: any) => item.tid === values.art_tid) || {}).name || values.art_tid_name || null;
            // const kategorie_tid: number = +values.kategorie_tid_orig || +values.kategorie_tid || null;
            if (art === 'Photovoltaikanlage') {
                processCallback(callback, { type: 'error' });
                return sysTxtPvScope3_2;
            }
        }
        case 'name': {
            const errMax: number = getPlausiValue('co2scope3.gueterkapital.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'menge': {
            const einheit: string = (data.values || {}).einheit || 'kg';
            const errMin: number = getPlausiValue('co2scope3.gueterkapital.menge.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.gueterkapital.menge.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Menge [${einheit}] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.gueterkapital.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.gueterkapital.faktor.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Faktor muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'quelle': {
            const errMax: number = getPlausiValue('co2scope3.gueterkapital.quelle.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
    }
    return null;
}

export function validateFieldCO2Scope3Investition(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'name': {
            const errMax: number = getPlausiValue('co2scope3.investition.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'einheit': {
            const errMax: number = getPlausiValue('co2scope3.investition.einheit.limitString.max', 12);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'menge': {
            const einheit: string = (data.values || {}).einheit || null;
            const errMin: number = getPlausiValue('co2scope3.investition.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.investition.menge.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Menge${einheit ? ` [${einheit}]` : ''} muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.investition.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.investition.faktor.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Faktor muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'quelle': {
            const errMax: number = getPlausiValue('co2scope3.investition.quelle.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
    }
    return null;
}

export function validateFieldCO2Scope3Lieferant(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    let errMax;
    switch (key) {
        case 'name':
            errMax = getPlausiValue('co2scope3.lieferant.name.limitString.max', 18);
            return limitString(key, value, errMax, onValueChange);
    }
    return null;
}

export function validateFieldCO2Scope3Pendeln(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'teilstrecken': {
            processCallback(callback, { type: 'warning' });
            return checkTeilstrecken(data.getAllValues());
        }
        case 'hin_rueck': {
            processCallback(callback, { type: 'warning' });
            return checkHinRueck(data.getAllValues(), 'Entfernung [km]');
        }
        case 'mitarbeiter': {
            const errMax: number = getPlausiValue('co2scope3.pendeln.mitarbeiter.limitString.max', 25);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'arbeitstage': {
            const errMin: number = getPlausiValue('co2scope3.pendeln.arbeitstage.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.pendeln.arbeitstage.error.max', 250);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Anzahl der Arbeitstage muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'entfernung': {
            const errMin: number = getPlausiValue('co2scope3.pendeln.entfernung.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.pendeln.entfernung.error.max', 99999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Entfernung [km] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'kosten': {
            const errMin: number = getPlausiValue('co2scope3.pendeln.kosten.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.pendeln.kosten.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Kosten [€] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'verbrauch': {
            const errMin: number = getPlausiValue('co2scope3.pendeln.verbrauch.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.pendeln.verbrauch.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Verbrauch muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'name_nutzer': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'einheit_nutzer': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.einheit.limitString.max', 12);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'menge_nutzer': {
            const einheit: string = (data.values || {}).einheit_nutzer || null;
            const errMin: number = getPlausiValue('co2scope3.emittenten.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.menge.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Menge${einheit ? ` [${einheit}]` : ''} muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'faktor_nutzer': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.faktor.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Faktor muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'quelle_nutzer': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.quelle.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
    }
    return null;
}

export function validateFieldCO2Scope3Produkte(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'name': {
            const errMax: number = getPlausiValue('co2scope3.produkte.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'einheit': {
            const errMax: number = getPlausiValue('co2scope3.produkte.einheit.limitString.max', 12);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'menge': {
            const einheit: string = (data.values || {}).einheit || null;
            const errMin: number = getPlausiValue('co2scope3.produkte.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.produkte.menge.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Menge${einheit ? ` [${einheit}]` : ''} muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.produkte.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.produkte.faktor.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Faktor muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'quelle': {
            const errMax: number = getPlausiValue('co2scope3.produkte.quelle.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
    }
    return null;
}

export function validateFieldCO2Scope3Reisen(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'teilstrecken': {
            processCallback(callback, { type: 'warning' });
            return checkTeilstrecken(data.getAllValues());
        }
        case 'hin_rueck': {
            processCallback(callback, { type: 'warning' });
            return checkHinRueck(data.getAllValues(), 'Entfernung [km]');
        }
        case 'personen': {
            const errMin: number = getPlausiValue('co2scope3.reisen.personen.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.reisen.personen.error.max', 100);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Personenanzahl muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'entfernung': {
            const errMin: number = getPlausiValue('co2scope3.reisen.entfernung.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.reisen.entfernung.error.max', 99999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Entfernung [km] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'kosten': {
            const errMin: number = getPlausiValue('co2scope3.reisen.kosten.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.reisen.kosten.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Kosten [€] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'verbrauch': {
            const errMin: number = getPlausiValue('co2scope3.reisen.verbrauch.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.reisen.verbrauch.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Verbrauch muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'uebernachtungen_anzahl': {
            const errMin: number = getPlausiValue('co2scope3.reisen.uebernachtungen_anzahl.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.reisen.uebernachtungen_anzahl.error.max', 99);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Anzahl der Übernachtungen muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'teilnehmer': {
            const errMin: number = getPlausiValue('co2scope3.reisen.teilnehmer.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.reisen.teilnehmer.error.max', 100);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Anzahl der Teilnehmer muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'name_nutzer': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'einheit_nutzer': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.einheit.limitString.max', 12);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'menge_nutzer': {
            const einheit: string = (data.values || {}).einheit_nutzer || null;
            const errMin: number = getPlausiValue('co2scope3.emittenten.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.menge.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Menge${einheit ? ` [${einheit}]` : ''} muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'faktor_nutzer': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.faktor.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Faktor muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'quelle_nutzer': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.quelle.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
    }
    return null;
}

export function validateFieldCO2Scope3TransportNachgelagert(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'teilstrecken': {
            processCallback(callback, { type: 'warning' });
            return checkTeilstrecken(data.getAllValues());
        }
        case 'hin_rueck': {
            processCallback(callback, { type: 'warning' });
            return checkHinRueck(data.getAllValues(), 'Transportstrecke [km]');
        }
        case 'entfernung': {
            const errMin: number = getPlausiValue('co2scope3.transport.entfernung.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.transport.entfernung.error.max', 25000);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Entfernung [km] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.transport.menge.error.min', 0.001);
            const errMax: number = getPlausiValue('co2scope3.transport.menge.error.max', 999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Das Warengewicht [t] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'kosten': {
            const errMin: number = getPlausiValue('co2scope3.transport.kosten.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.transport.kosten.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Kosten [€] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'verbrauch': {
            const errMin: number = getPlausiValue('co2scope3.transport.verbrauch.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.transport.verbrauch.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Verbrauch muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'name_nutzer': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'einheit_nutzer': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.einheit.limitString.max', 12);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'menge_nutzer': {
            const einheit: string = (data.values || {}).einheit_nutzer || null;
            const errMin: number = getPlausiValue('co2scope3.emittenten.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.menge.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Menge${einheit ? ` [${einheit}]` : ''} muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'faktor_nutzer': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.faktor.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Faktor muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'quelle_nutzer': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.quelle.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'personen': {
            const errMin: number = getPlausiValue('co2scope3.transport.personen.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.transport.personen.error.max', 100);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Personenanzahl muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'uebernachtungen_anzahl': {
            const errMin: number = getPlausiValue('co2scope3.transport.uebernachtungen_anzahl.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.transport.uebernachtungen_anzahl.error.max', 99);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Anzahl der Übernachtungen muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
    }
    return null;
}

export function validateFieldCO2Scope3TransportVorgelagert(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'teilstrecken': {
            processCallback(callback, { type: 'warning' });
            return checkTeilstrecken(data.getAllValues());
        }
        case 'hin_rueck': {
            processCallback(callback, { type: 'warning' });
            return checkHinRueck(data.getAllValues(), 'Transportstrecke [km]');
        }
        case 'entfernung': {
            const errMin: number = getPlausiValue('co2scope3.transport.entfernung.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.transport.entfernung.error.max', 25000);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Entfernung [km] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'menge': {
            const errMin: number = getPlausiValue('co2scope3.transport.menge.error.min', 0.001);
            const errMax: number = getPlausiValue('co2scope3.transport.menge.error.max', 999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Das Warengewicht [t] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'kosten': {
            const errMin: number = getPlausiValue('co2scope3.transport.kosten.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.transport.kosten.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Kosten [€] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'verbrauch': {
            const errMin: number = getPlausiValue('co2scope3.transport.verbrauch.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.transport.verbrauch.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Verbrauch muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'name_nutzer': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'einheit_nutzer': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.einheit.limitString.max', 12);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'menge_nutzer': {
            const einheit: string = (data.values || {}).einheit_nutzer || null;
            const errMin: number = getPlausiValue('co2scope3.emittenten.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.menge.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Menge${einheit ? ` [${einheit}]` : ''} muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'faktor_nutzer': {
            const errMin: number = getPlausiValue('co2scope3.emittenten.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.emittenten.faktor.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Faktor muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'quelle_nutzer': {
            const errMax: number = getPlausiValue('co2scope3.emittenten.quelle.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'personen': {
            const errMin: number = getPlausiValue('co2scope3.transport.personen.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.transport.personen.error.max', 100);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Personenanzahl muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
    }
    return null;
}

export function validateFieldCO2Scope3VermieteteSachanlagen(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'name': {
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'einheit': {
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.einheit.limitString.max', 12);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'menge': {
            const einheit: string = (data.values || {}).einheit || null;
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.menge.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.menge.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Menge${einheit ? ` [${einheit}]` : ''} muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'faktor': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.faktor.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.faktor.error.max', 99999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Faktor muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'quelle': {
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.quelle.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
    }
    return null;
}

export function validateFieldCO2Scope3VermieteteSachanlagenFahrzeuge(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'name': {
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'verbrauch': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.verbrauch.error.min', 0);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.verbrauch.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Verbrauch muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
    }
    return null;
}

export function validateFieldCO2Scope3VermieteteSachanlagenRaeumlichkeiten(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'flaeche_gesamt': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.flaeche_gesamt.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.flaeche_gesamt.error.max', 999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Gesamtfläche [m²] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'flaeche': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.flaeche.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.flaeche.error.max', 999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Fläche [m²] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            return checkCO2Scope3RaeumlichkeitenFlaeche(data, callback);
        }
        case 'vermietungstage': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.vermietungstage.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.vermietungstage.error.max', 366);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Vermietungstage [Tage/Jahr] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'nutzungszeit': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.nutzungszeit.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.nutzungszeit.error.max', 24);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Nutzungszeit [h/Tag] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
    }
    return null;
}

export function validateFieldCO2Scope3VermieteteSachanlagenTechnik(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'name': {
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'leistung': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.leistung.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.leistung.error.max', 99999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Leistung [kW] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'vermietungstage': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.vermietungstage.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.vermietungstage.error.max', 366);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Vermietungstage [Tage/Jahr] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'nutzungszeit': {
            const errMin: number = getPlausiValue('co2scope3.sachanlagen.nutzungszeit.error.min', 1);
            const errMax: number = getPlausiValue('co2scope3.sachanlagen.nutzungszeit.error.max', 24);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Nutzungszeit [h/Tag] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
    }
    return null;
}

export function validateFieldEigenstrom(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    const { values } = data;
    const abrechnungszeitraum_bis: number = values.abrechnungszeitraum_bis || -1;
    const abrechnungszeitraum_von: number = values.abrechnungszeitraum_von || -1;
    const jahr: number = values.jahr || null;
    let errMin, errMax;
    switch (key) {
        case 'abrechnungszeitraum_bis':
            const check1 = checkAZ(key, jahr, abrechnungszeitraum_von, abrechnungszeitraum_bis, dataGlobal, callback);
            if (check1) { return check1; }
            /*const checkOver1 = checkAZOverlap(IDs.ENT_ENERGIEDATEN_EIGENSTROM, values, dataGlobal);
            if (checkOver1) {
                processCallback(callback, { type: 'warning' });
                return checkOver1;
            }*/
            break;
        case 'abrechnungszeitraum_von':
            const check2 = checkAZ(key, jahr, abrechnungszeitraum_von, abrechnungszeitraum_bis, dataGlobal, callback);
            if (check2) { return check2; }
            /*const checkOver2 = checkAZOverlap(IDs.ENT_ENERGIEDATEN_EIGENSTROM, values, dataGlobal);
            if (checkOver2) {
                processCallback(callback, { type: 'warning' });
                return checkOver2;
            }*/
            break;
        case 'einspeiseverguetung':
            errMin = getPlausiValue('eigenstrom.einspeiseverguetung.error.min', 0);
            errMax = getPlausiValue('eigenstrom.einspeiseverguetung.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Einspeisevergütung [€] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            return checkStromEinspeiseverguetung(data, callback);
        case 'gesamtproduktion_kwh':
            errMin = getPlausiValue('eigenstrom.gesamtproduktion_kwh.error.min', 0);
            errMax = getPlausiValue('eigenstrom.gesamtproduktion_kwh.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Gesamtproduktion [kWh] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            const typ: string = getEigenstromtypKey(values);
            return checkKennzahl(`eigenstrom_${typ}_produktion_kwh`, values, dataGlobal, callback, 'Unterschied: Gesamtproduktion ');
        case 'kalibrierung':
        // no break
        case 'messsystem':
            errMax = getPlausiValue('eigenstrom.messsystem.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        case 'netzeinspeisung_kwh':
            errMin = getPlausiValue('eigenstrom.netzeinspeisung_kwh.error.min', 0);
            errMax = getPlausiValue('eigenstrom.netzeinspeisung_kwh.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Netzeinspeisung [kWh] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            return checkStromNetzeinspeisung(data, callback);
    }
    return null;
}

export function validateFieldEigenstromBiomasse(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    let errMin, errMax;
    switch (key) {
        case 'art_hersteller':
        // no break
        case 'name':
            errMax = getPlausiValue('eigenstrom.biomasse.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        case 'installations_jahr':
            errMin = getPlausiValue('eigenstrom.biomasse.installations_jahr.error.min', 1950);
            if (isSomeKindOfNumber(value) && (!Number.isInteger(value) || +value < errMin || +value > Moment().year())) {
                processCallback(callback, { type: 'error' });
                return `Das Installationsjahr muss im Bereich [${errMin} - ${Moment().year()}] liegen`;
            }
            break;
        case 'leistung':
            errMin = getPlausiValue('eigenstrom.biomasse.leistung.error.min', 1);
            errMax = getPlausiValue('eigenstrom.biomasse.leistung.error.max', 9999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                if (+value > errMax) {
                    processCallback(callback, { type: 'warning' });
                    return 'Die Anlagenleistung [kW] ist ungewöhnlich hoch. Bitte überprüfen Sie die Dateneingabe nocheinmal.';
                } else {
                    processCallback(callback, { type: 'error' });
                    return `Die Anlagenleistung [kW] muss im Bereich [${errMin} - ${errMax}] liegen`;
                }
            }
            break;
    }
    return null;
}

export function validateFieldEigenstromKwk(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    let errMin, errMax;
    switch (key) {
        case 'hersteller':
        // no break
        case 'name':
            errMax = getPlausiValue('eigenstrom.kwk.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        case 'leistung_elektrisch':
        // no break
        case 'leistung_thermisch':
            errMin = getPlausiValue('eigenstrom.kwk.leistung_thermisch.error.min', 1);
            errMax = getPlausiValue('eigenstrom.kwk.leistung_thermisch.error.max', 25000);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Leistung [kWh] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
    }
    return null;
}

export function validateFieldEigenstromPhotovoltaik(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    let errMin, errMax;
    switch (key) {
        case 'leistung':
            errMin = getPlausiValue('eigenstrom.photovoltaik.leistung.error.min', 1);
            errMax = getPlausiValue('eigenstrom.photovoltaik.leistung.error.max', 999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                if (+value > errMax) {
                    processCallback(callback, { type: 'warning' });
                    return 'Die Anlagenleistung [kWp] ist ungewöhnlich hoch. Bitte überprüfen Sie die Dateneingabe nocheinmal.';
                } else {
                    processCallback(callback, { type: 'error' });
                    return `Die Anlagenleistung [kWp] muss im Bereich [${errMin} - ${errMax}] liegen`;
                }
            }
            break;
        case 'leistung_wechselrichter':
            errMin = getPlausiValue('eigenstrom.photovoltaik.leistung_wechselrichter.error.min', 1);
            errMax = getPlausiValue('eigenstrom.photovoltaik.leistung_wechselrichter.error.max', 999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                if (+value > errMax) {
                    processCallback(callback, { type: 'warning' });
                    return 'Die Wechselrichterleistung [kW] ist ungewöhnlich hoch. Bitte überprüfen Sie die Dateneingabe nocheinmal.';
                } else {
                    processCallback(callback, { type: 'error' });
                    return `Die Wechselrichterleistung [kW] muss im Bereich [${errMin} - ${errMax}] liegen`;
                }
            }
            break;
        case 'modul':
        // no break
        case 'name':
        // no break
        case 'wechselrichter':
            errMax = getPlausiValue('eigenstrom.photovoltaik.wechselrichter.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        case 'modul_anzahl':
            errMin = getPlausiValue('eigenstrom.photovoltaik.modul_anzahl.error.min', 1);
            errMax = getPlausiValue('eigenstrom.photovoltaik.modul_anzahl.error.max', 9999);
            if (isSomeKindOfNumber(value) && (!Number.isInteger(value) || +value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Modulfläche [m²] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'modul_flaeche':
            errMin = getPlausiValue('eigenstrom.photovoltaik.modul_flaeche.error.min', 1);
            errMax = getPlausiValue('eigenstrom.photovoltaik.modul_flaeche.error.max', 9999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Anzahl der Module muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'modul_neigung':
            errMin = getPlausiValue('eigenstrom.photovoltaik.modul_neigung.error.min', 0);
            errMax = getPlausiValue('eigenstrom.photovoltaik.modul_neigung.error.max', 90);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Modulneigung [Grad] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
    }
    return null;
}

export function validateFieldEigenstromSolarthermie(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    let errMin, errMax;
    switch (key) {
        case 'art_hersteller':
        // no break
        case 'name':
            errMax = getPlausiValue('eigenstrom.solarthermie.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        case 'installations_jahr':
            errMin = getPlausiValue('eigenstrom.solarthermie.installations_jahr.error.min', 1950);
            if (isSomeKindOfNumber(value) && (!Number.isInteger(value) || +value < errMin || +value > Moment().year())) {
                processCallback(callback, { type: 'error' });
                return `Das Anschaffungsjahr muss im Bereich [${errMin} - ${Moment().year()}] liegen`;
            }
            break;
        case 'kollektor_flaeche':
            errMin = getPlausiValue('eigenstrom.solarthermie.kollektor_flaeche.error.min', 1);
            errMax = getPlausiValue('eigenstrom.solarthermie.kollektor_flaeche.error.max', 999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Kollektorfläche [m²] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'kollektor_neigung':
            errMin = getPlausiValue('eigenstrom.solarthermie.kollektor_neigung.error.min', 0);
            errMax = getPlausiValue('eigenstrom.solarthermie.kollektor_neigung.error.max', 90);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Kollektor-Neigung [Grad] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
    }
    return null;
}

export function validateFieldEigenstromWaermepumpen(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    let errMin, errMax;
    switch (key) {
        case 'art_hersteller':
        // no break
        case 'name':
            errMax = getPlausiValue('eigenstrom.waermepumpen.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        case 'installations_jahr':
            errMin = getPlausiValue('eigenstrom.waermepumpen.installations_jahr.error.min', 1950);
            if (isSomeKindOfNumber(value) && (!Number.isInteger(value) || +value < errMin || +value > Moment().year())) {
                processCallback(callback, { type: 'error' });
                return `Das Anschaffungsjahr muss im Bereich [${errMin} - ${Moment().year()}] liegen`;
            }
            break;
        case 'leistung':
            errMin = getPlausiValue('eigenstrom.waermepumpen.leistung.error.min', 1);
            errMax = getPlausiValue('eigenstrom.waermepumpen.leistung.error.max', 999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Leistung [kW] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
    }
    return null;
}

export function validateFieldEigenstromWindkraft(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    let errMin, errMax;
    switch (key) {
        case 'anlaufgeschwindigkeit':
            errMin = getPlausiValue('eigenstrom.windkraft.anlaufgeschwindigkeit.error.min', 1);
            errMax = getPlausiValue('eigenstrom.windkraft.anlaufgeschwindigkeit.error.max', 9);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Anlaufgeschwindigkeit [m/s] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'art_hersteller':
        // no break
        case 'name':
        // no break
        case 'wechselrichter':
            errMax = getPlausiValue('eigenstrom.windkraft.wechselrichter.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        case 'leistung':
        // no break
        case 'leistung_wechselrichter':
            errMin = getPlausiValue('eigenstrom.windkraft.leistung_wechselrichter.error.min', 1);
            errMax = getPlausiValue('eigenstrom.windkraft.leistung_wechselrichter.error.max', 9999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Leistung [kW] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'mittlere_windgeschwindigkeit':
            errMin = getPlausiValue('eigenstrom.windkraft.mittlere_windgeschwindigkeit.error.min', 1);
            errMax = getPlausiValue('eigenstrom.windkraft.mittlere_windgeschwindigkeit.error.max', 99);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Windstärke [m/s] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'naben_höhe':
            errMin = getPlausiValue('eigenstrom.windkraft.naben_höhe.error.min', 1);
            errMax = getPlausiValue('eigenstrom.windkraft.naben_höhe.error.max', 50);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Höhe [m] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'rotoren_durchmesser':
            errMin = getPlausiValue('eigenstrom.windkraft.rotoren_durchmesser.error.min', 1);
            errMax = getPlausiValue('eigenstrom.windkraft.rotoren_durchmesser.error.max', 99);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Rotorendurchmesser [m] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
    }
    return null;
}

export function validateFieldFahrzeuge(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'anschaffungsjahr':
            return checkAnschaffungsjahr(key, value, data, onValueChange, callback);
        case 'baujahr':
            return checkFahrzeugbaujahr(key, value, onValueChange, callback);
        case 'jahr_status':
            return checkFahrzeugJahrStatus(key, value, data, onValueChange, callback);
        case 'laufleistung':
            return checkFahrzeugJahreslaufleistung(key, value, data, onValueChange, callback);
        case 'leistung':
            return checkFahrzeugleistung(key, value, data, onValueChange, callback);
        case 'name':
            return limitString(key, value, 45, onValueChange);
    }
    return null;
}

export function validateFieldFahrzeugeJahreswerte(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    let errMin, errMax;
    switch (key) {
        case 'laufleistung':
            errMin = getPlausiValue('fahrzeugeJahreswerte.laufleistung.error.min', 1);
            errMax = getPlausiValue('fahrzeugeJahreswerte.laufleistung.error.max', 99000);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Jahreslaufleistung [km] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
    }
    return null;
}

export function validateFieldKlimagase(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'menge':
            return checkKlimagasmenge(key, value, data, onValueChange, callback);
    }
    return null;
}

export function validateFieldKraftstoffe(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any, doValidate?: boolean) => void, dataGlobal?: any,
    callback?: (data: any) => void
): string {
    const { values } = data;
    const abrechnungszeitraum_bis: number = values.abrechnungszeitraum_bis || -1;
    const abrechnungszeitraum_von: number = values.abrechnungszeitraum_von || -1;
    const jahr: number = values.jahr || null;
    let errMin, errMax;
    switch (key) {
        case 'abrechnungszeitraum_bis':
            const check1 = checkAZ(key, jahr, abrechnungszeitraum_von, abrechnungszeitraum_bis, dataGlobal, callback);
            if (check1) { return check1; }
            break;
        case 'abrechnungszeitraum_von':
            const check2 = checkAZ(key, jahr, abrechnungszeitraum_von, abrechnungszeitraum_bis, dataGlobal, callback);
            if (check2) { return check2; }
            break;
        case 'kalibrierung':
        // no break
        case 'messsystem':
            errMax = getPlausiValue('kraftstoffe.messsystem.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        case 'kosten': {
            errMin = getPlausiValue('kraftstoffe.kosten.error.min', 0);
            errMax = getPlausiValue('kraftstoffe.kosten.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Kosten [€] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            let message2: string = null;
            let message: string = checkKraftstoffpreis(data, (data: any) => {
                // if ((data || {}).type !== 'error') {
                //     message2 = checkKennzahl('kraftstoffe_kosten', values, dataGlobal, callback, 'Unterschied: Gesamtkosten ');
                // }
                if (!message2 && typeof callback === 'function') {
                    callback(data);
                }
            });
            return message2 ? message2 : message;
        }
        case 'laufleistung':
            return checkKraftstoffJahreslaufleistung(key, value, data, onValueChange, callback);
        case 'verbrauch': {
            errMin = getPlausiValue('kraftstoffe.verbrauch.error.min', 0);
            errMax = getPlausiValue('kraftstoffe.verbrauch.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Verbrauch muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            let message2: string = null;
            let message: string = checkKraftstoffpreis(data, (data: any) => {
                // if ((data || {}).type !== 'error') {
                //     message2 = checkKennzahl('kraftstoff_kwh', values, dataGlobal, callback, 'Unterschied: Gesamtverbrauch ');
                // }
                if (!message2 && typeof callback === 'function') {
                    callback(data);
                }
            });
            return message2 ? message2 : message;
        }
        case 'fahrzeug_tid':
            const fahrzeug = ((dataGlobal || {})[IDs.ENT_FAHRZEUGE] || []).find((f: any) => f.tid === +values.fahrzeug_tid_orig || f.tid === +values.fahrzeug_tid);
            if (onValueChange && fahrzeug) {
                // Der Kraftstoff des Fahrzeuges wird automatisch übernommen.
                let energietraeger_tid = fahrzeug.energiedaten_kraftstoff_energietraeger_orig || fahrzeug.energiedaten_kraftstoff_energietraeger;
                // "Erdgas [kWh]" und "Wasserstoff [kWh]" sollen nicht erscheinen. Siehe filterBundleForForm auch.
                if (energietraeger_tid === 4 || energietraeger_tid === 5) {
                    energietraeger_tid = 0;
                }
                if (energietraeger_tid > 0 && values.energietraeger_tid !== energietraeger_tid) {
                    onValueChange('energietraeger_tid', energietraeger_tid, false);
                }
            }
            return null;
    }
    return null;
}

export function validateFieldMaschinen(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    let errMin, errMax;
    switch (key) {
        case 'abwaerme':
            return checkAbwaerme(key, value, onValueChange, callback);
        case 'auslastungsfaktor':
            errMin = getPlausiValue('maschinen.auslastungsfaktor.error.min', 1);
            errMax = getPlausiValue('maschinen.auslastungsfaktor.error.max', 100);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Auslastungsfaktor [%] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'baujahr':
            return checkMaschinenbaujahr(key, value, onValueChange, callback);
        case 'betriebszeit_h_tag':
            errMin = getPlausiValue('maschinen.betriebszeit_h_tag.error.min', 1);
            errMax = getPlausiValue('maschinen.betriebszeit_h_tag.error.max', 24);
            if (isSomeKindOfNumber(value) && (/*!Number.isInteger(value) || */+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Betriebszeit [h/Tag] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'betriebszeit_tage_jahr':
            errMin = getPlausiValue('maschinen.betriebszeit_tage_jahr.error.min', 1);
            errMax = getPlausiValue('maschinen.betriebszeit_tage_jahr.error.max', 366);
            if (isSomeKindOfNumber(value) && (!Number.isInteger(value) || +value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Betriebszeit [Tage/Jahr] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'jahr_status':
            return checkMaschineJahrStatus(key, value, data, onValueChange, callback);
        case 'leistung':
            return checkAnschlussleistung(key, value, onValueChange, callback);
        case 'messwert_unterzaehler':
            errMin = getPlausiValue('maschinen.messwert_unterzaehler.error.min', 0);
            errMax = getPlausiValue('maschinen.messwert_unterzaehler.error.max', 999999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Unterzählermesswert muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'name':
            errMax = getPlausiValue('maschinen.name.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
    }
    return null;
}

export function validateFieldMaschinenJahreswerte(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    let errMin, errMax;
    switch (key) {
        case 'auslastungsfaktor':
            errMin = getPlausiValue('maschinen.auslastungsfaktor.error.min', 1);
            errMax = getPlausiValue('maschinen.auslastungsfaktor.error.max', 100);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Auslastungsfaktor [%] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'betriebszeit_h_tag':
            errMin = getPlausiValue('maschinen.betriebszeit_h_tag.error.min', 1);
            errMax = getPlausiValue('maschinen.betriebszeit_h_tag.error.max', 24);
            if (isSomeKindOfNumber(value) && (/*!Number.isInteger(value) || */+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Betriebszeit [h/Tag] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'betriebszeit_tage_jahr':
            errMin = getPlausiValue('maschinen.betriebszeit_tage_jahr.error.min', 1);
            errMax = getPlausiValue('maschinen.betriebszeit_tage_jahr.error.max', 366);
            if (isSomeKindOfNumber(value) && (!Number.isInteger(value) || +value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Betriebszeit [Tage/Jahr] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'messwert_unterzaehler':
            errMin = getPlausiValue('maschinen.messwert_unterzaehler.error.min', 0);
            errMax = getPlausiValue('maschinen.messwert_unterzaehler.error.max', 999999999);
            if (isSomeKindOfNumber(value) && (+value < 0 || +value > 999999999)) {
                processCallback(callback, { type: 'error' });
                return `Der Unterzählermesswert muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
    }
    return null;
}

export function validateFieldOelabrechnung(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    if ((data || {}).hasOwnProperty('setBundle')) {
        data.setBundle((dataGlobal || {})[`${IDs.ENT_OEL_ABRECHNUNG}_bundle`] || {});
    }
    switch (key) {
        case 'fuellmenge':
            const errMin: number = getPlausiValue('oelabrechnung.fuellmenge.error.min', 1);
            const errMax: number = getPlausiValue('oelabrechnung.fuellmenge.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Füllmenge muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            return checkWaermepreis(data, dataGlobal, callback);
        case 'kosten': {
            const errMin: number = getPlausiValue('oelabrechnung.kosten.error.min', 1);
            const errMax: number = getPlausiValue('oelabrechnung.kosten.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Kosten [€] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            return checkWaermepreis(data, dataGlobal, callback);
        }
    }
    return null;
}

export function validateFieldRaeumlichkeiten(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'nutzungstage': {
            const errMin: number = getPlausiValue('raeumlichkeiten.nutzungstage.error.min', 1);
            const errMax: number = getPlausiValue('raeumlichkeiten.nutzungstage.error.max', 366);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Nutzungstage [Tage/Jahr] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'nutzungszeit': {
            const errMin: number = getPlausiValue('raeumlichkeiten.nutzungszeit.error.min', 1);
            const errMax: number = getPlausiValue('raeumlichkeiten.nutzungszeit.error.max', 24);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Nutzungszeit [h/Tag] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'flaeche': {
            const errMin: number = getPlausiValue('raeumlichkeiten.flaeche.error.min', 1);
            const errMax: number = getPlausiValue('raeumlichkeiten.flaeche.error.max', 99999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Fläche [m²] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'flaeche_gebaeude': {
            const errMin: number = getPlausiValue('raeumlichkeiten.flaeche_gebaeude.error.min', 1);
            const errMax: number = getPlausiValue('raeumlichkeiten.flaeche_gebaeude.error.max', 99999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Gebäudeenergiebezugsfläche [m²] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            return checkRaeumlichkeitenFlaecheGebaude(data, callback);
        }
        case 'faktor_kaelte': {
            const errMin: number = getPlausiValue('raeumlichkeiten.faktor_kaelte.error.min', 0);
            const errMax: number = getPlausiValue('raeumlichkeiten.faktor_kaelte.error.max', 1000);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Faktor muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
    }
    return null;
}

export function validateFieldSonstigeDaten(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void
): string {
    let errMax;
    switch (key) {
        case 'erfasst_von':
        // no break
        case 'institution':
            errMax = getPlausiValue('sonstigeDaten.institution.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
    }
    return null;
}

export function validateFieldStandort(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'hausnummer':
            return checkHausnummer(key, value, onValueChange);
        case 'plz':
            return checkPlz(key, value, onValueChange, callback);
        case 'standort_typ_tid':
            const standort_tid = data.values.tid || null;
            const hauptsitzAnzahl = getStandortHauptsitzAnzahl(standort_tid, dataGlobal) || 0;
            if (value && +value === 1 && +hauptsitzAnzahl > 0) { // {1} Hauptsitz
                processCallback(callback, { type: 'error' });
                return 'Es darf nur einen Hauptsitz geben';
            }
            break;
    }
    return null;
}

export function validateFieldStrom(
    key: string, value: any, data: any, onValueChange?: (name: string, value: any) => void, dataGlobal?: any,
    callback?: (data: any) => void
): string {
    const { values } = data;
    const abrechnungszeitraum_bis: number = values.abrechnungszeitraum_bis || -1;
    const abrechnungszeitraum_von: number = values.abrechnungszeitraum_von || -1;
    const jahr: number = values.jahr || null;
    let errMin, errMax;
    switch (key) {
        case 'abrechnungsmodus':
            return checkAbrechnungsmodusMonat(value, data, IDs.ENT_ENERGIEDATEN_STROM, dataGlobal, callback);
        case 'abrechnungszeitraum_bis':
            const check1 = checkAZ(key, jahr, abrechnungszeitraum_von, abrechnungszeitraum_bis, dataGlobal, callback);
            if (check1) { return check1; }
            break;
        case 'abrechnungszeitraum_von':
            const check2 = checkAZ(key, jahr, abrechnungszeitraum_von, abrechnungszeitraum_bis, dataGlobal, callback);
            if (check2) { return check2; }
            break;
        case 'co2_emissionen':
            errMin = getPlausiValue('strom.co2_emissionen.error.min', 0);
            errMax = getPlausiValue('strom.co2_emissionen.error.max', 999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die CO₂-Emissionen [gCO₂/kWh] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        case 'kalibrierung':
        // no break
        case 'messsystem':
        // no break
        case 'stromanbieter':
            errMax = getPlausiValue('strom.stromanbieter.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        case 'kosten_netto': {
            errMin = getPlausiValue('strom.kosten_netto.error.min', 0);
            errMax = getPlausiValue('strom.kosten_netto.error.max', 999999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Nettostromkosten [€] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            let message2: string = null;
            let message: string = checkStrompreis(data, (data: any) => {
                if ((data || {}).type !== 'error') {
                    // message2 = checkKennzahl('kosten_strom', values, dataGlobal, callback, 'Unterschied: Gesamtkosten ');
                    message2 = checkZaehlerwert(
                        key, values, IDs.ENT_ENERGIEDATEN_STROM, dataGlobal, callback, 'Unterschied: Kosten '
                    );
                    // message2 = joinMessages([message2, message3]);
                }
                if (!message2 && typeof callback === 'function') {
                    callback(data);
                }
            });
            return message2 ? message2 : message;
        }
        case 'spitzenlast':
            return checkStromspitzenlast(data, callback);
        case 'verbrauch_kwh': {
            errMin = getPlausiValue('strom.verbrauch_kwh.error.min', 0);
            errMax = getPlausiValue('strom.verbrauch_kwh.error.max', 999999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Stromverbrauch [kWh] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            let message2: string = null;
            let message: string = checkStrompreis(data, (data: any) => {
                if ((data || {}).type !== 'error') {
                    // message2 = checkKennzahl('verbrauch_strom', values, dataGlobal, callback, 'Unterschied: Gesamtverbrauch ');
                    message2 = checkZaehlerwert(
                        key, values, IDs.ENT_ENERGIEDATEN_STROM, dataGlobal, callback, 'Unterschied: Verbrauch '
                    );
                    // message2 = joinMessages([message2, message3]);
                }
                if (!message2 && typeof callback === 'function') {
                    callback(data);
                }
            });
            return message2 ? message2 : message;
        }
    }
    return null;
}

export function validateFieldUnternehmensdaten(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any, callback?: (data: any) => void
): string {
    switch (key) {
        case 'email':
            return checkEmail(value, callback);
        case 'hausnummer':
            return checkHausnummer(key, value, onValueChange);
        case 'plz':
            return checkPlz(key, value, onValueChange, callback);
        case 'wz_tid':
            return checkGewerbe(data.getAllValues(), dataGlobal, callback);
    }
    return null;
}

export function validateFieldWaerme(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any,
    callback?: (data: any) => void
): string {
    const { values } = data;
    const abrechnungszeitraum_bis: number = values.abrechnungszeitraum_bis || -1;
    const abrechnungszeitraum_von: number = values.abrechnungszeitraum_von || -1;
    const jahr: number = values.jahr || null;
    switch (key) {
        case 'abrechnungsmodus':
            return checkAbrechnungsmodusMonat(value, data, IDs.ENT_ENERGIEDATEN_WAERME, dataGlobal, callback);
        case 'abrechnungszeitraum_bis':
            const check1 = checkAZ(key, jahr, abrechnungszeitraum_von, abrechnungszeitraum_bis, dataGlobal, callback);
            if (check1) { return check1; }
            break;
        case 'abrechnungszeitraum_von':
            const check2 = checkAZ(key, jahr, abrechnungszeitraum_von, abrechnungszeitraum_bis, dataGlobal, callback);
            if (check2) { return check2; }
            break;
        case 'co2_emissionen': {
            if (values.einheit_tid === 7 /* MWh */) {
                const errMin: number = getPlausiValue('waerme.co2_emissionen_mwh.error.min', 0);
                const errMax: number = getPlausiValue('waerme.co2_emissionen_mwh.error.max', 999999);
                if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                    processCallback(callback, { type: 'error' });
                    return `Die CO₂-Emissionen [gCO₂/MWh] müssen im Bereich [${errMin} - ${errMax}] liegen`;
                }
            } else {
                const errMin: number = getPlausiValue('waerme.co2_emissionen.error.min', 0);
                const errMax: number = getPlausiValue('waerme.co2_emissionen.error.max', 999);
                if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                    processCallback(callback, { type: 'error' });
                    return `Die CO₂-Emissionen [gCO₂/kWh] müssen im Bereich [${errMin} - ${errMax}] liegen`;
                }
            }
            break;
        }
        case 'kalibrierung':
        // no break
        case 'messsystem': {
            const errMax: number = getPlausiValue('waerme.messsystem.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        }
        case 'kosten': {
            const errMin: number = getPlausiValue('waerme.kosten.error.min', 0);
            const errMax: number = getPlausiValue('waerme.kosten.error.max', 999999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Kosten [€] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            let message2: string = null;
            let message: string = checkWaermepreis(data, dataGlobal, (data: any) => {
                if ((data || {}).type !== 'error') {
                    // message2 = checkKennzahl(
                    //     'kosten_waerme', values, dataGlobal, callback, 'Unterschied: Gesamtkosten (alle Energieträger) '
                    // );
                    message2 = checkZaehlerwert(
                        key, values, IDs.ENT_ENERGIEDATEN_WAERME, dataGlobal, callback, 'Unterschied: Kosten '
                    );
                    // message2 = joinMessages([message2, message3]);
                }
                if (!message2 && typeof callback === 'function') {
                    callback(data);
                }
            });
            return message2 ? message2 : message;
        }
        case 'prozess_waerme': {
            const errMin: number = getPlausiValue('waerme.prozess_waerme.error.min', 0);
            const errMax: number = getPlausiValue('waerme.prozess_waerme.error.max', 100);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Anteil Prozesswärme [%] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'verbrauch': {
            const convertValue = (value: number): number => {
                const einheit: string = ((data.getBundleValues('einheit_tid') || [])
                    .find((item: any) => item.tid === values.einheit_tid) || {}).name || values.einheit_tid_name || null;
                return einheit === 'MWh' && typeof value === 'number' ? parseInt((value / 1000).toString(), 10) : value;
            };
            const errMin: number = convertValue(getPlausiValue('waerme.verbrauch.error.min', 0));
            const errMax: number = convertValue(getPlausiValue('waerme.verbrauch.error.max', 999999999));
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Der Verbrauch muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            let message2: string = null;
            let message: string = checkWaermepreis(data, dataGlobal, (data2: any) => {
                if ((data2 || {}).type !== 'error') {
                    // message2 = checkKennzahl(
                    //     'verbrauch_waerme_kwh', values, dataGlobal, callback, 'Unterschied: Gesamtverbrauch (alle Energieträger) '
                    // );
                    message2 = checkZaehlerwert(
                        key, values, IDs.ENT_ENERGIEDATEN_WAERME, dataGlobal, callback, 'Unterschied: Verbrauch '
                    );
                    // message2 = joinMessages([message2, message3]);
                }
                if (!message2 && typeof callback === 'function') {
                    callback(data2);
                }
            });
            return message2 ? message2 : message;
        }
    }
    return null;
}

export function validateFieldVsmeBpm3(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal: any,
    callback?: (data: any) => void
): string {
    const { values } = data;
    const entities: string[] = [IDs.ENT_VSME_BPM3_SCOPE1, IDs.ENT_VSME_BPM3_SCOPE2];
    const jahr: number = values.jahr || null;
    const validValues: number = entities.reduce((sum: number, entity: string) =>
        sum + +((dataGlobal || {})[entity] || [])
            .filter((item: any) => item.jahr === jahr)
            .some((item: any) => isValid(item, entity, dataGlobal)), 0
    );
    if (key === 'ziele' && value === 1 && validValues !== entities.length) {
        // VSME: BP3: Pflichtfelder bei den Minderungzielen würde ich auflösen, da wir diese im Report nicht darstellen
        // processCallback(callback, { type: 'error' });
        // return 'Die Ziele sind unvollständig bzw. fehlerhaft';
    }
    return null;
}

export function validateFieldVsmeBpm3Scope1(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any,
    callback?: (data: any) => void
): string {
    const prefix: string = 'vsme.bpm3.scope1';
    switch (key) {
        case 'basisjahr': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 2010);
            if (isSomeKindOfNumber(value) && (!Number.isInteger(value) || +value < errMin || +value > Moment().year())) {
                processCallback(callback, { type: 'error' });
                return `Das Basisjahr muss im Bereich [${errMin} - ${Moment().year()}] liegen`;
            }
            break;
        }
        case 'emissionseinsparung_kurzfristig': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 0);
            const errMax: number = getPlausiValue(`${prefix}.${key}.error.max`, 100);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die kurzfristige Emissionseinsparung [%] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'emissionseinsparung_mittelfristig': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 0);
            const errMax: number = getPlausiValue(`${prefix}.${key}.error.max`, 100);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die mittelfristige Emissionseinsparung [%] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'emissionseinsparung_langfristig': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 0);
            const errMax: number = getPlausiValue(`${prefix}.${key}.error.max`, 100);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die langfristige Emissionseinsparung [%] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
    }
    return null;
}

export function validateFieldVsmeBpm3Scope2(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any,
    callback?: (data: any) => void
): string {
    const prefix: string = 'vsme.bpm3.scope2';
    switch (key) {
        case 'basisjahr': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 2010);
            if (isSomeKindOfNumber(value) && (!Number.isInteger(value) || +value < errMin || +value > Moment().year())) {
                processCallback(callback, { type: 'error' });
                return `Das Basisjahr muss im Bereich [${errMin} - ${Moment().year()}] liegen`;
            }
            break;
        }
        case 'emissionseinsparung_kurzfristig': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 0);
            const errMax: number = getPlausiValue(`${prefix}.${key}.error.max`, 100);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die kurzfristige Emissionseinsparung [%] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'emissionseinsparung_mittelfristig': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 0);
            const errMax: number = getPlausiValue(`${prefix}.${key}.error.max`, 100);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die mittelfristige Emissionseinsparung [%] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
        case 'emissionseinsparung_langfristig': {
            const errMin: number = getPlausiValue(`${prefix}.${key}.error.min`, 0);
            const errMax: number = getPlausiValue(`${prefix}.${key}.error.max`, 100);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die langfristige Emissionseinsparung [%] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
        }
    }
    return null;
}

export function validateFieldWasser(
    key: string, value: any, data: any, onValueChange: (name: string, value: any) => void, dataGlobal?: any,
    callback?: (data: any) => void
): string {
    const { values } = data;
    const abrechnungszeitraum_bis: number = values.abrechnungszeitraum_bis || -1;
    const abrechnungszeitraum_von: number = values.abrechnungszeitraum_von || -1;
    const jahr: number = values.jahr || null;
    let errMin, errMax;
    switch (key) {
        case 'abrechnungszeitraum_bis':
            const check1 = checkAZ(key, jahr, abrechnungszeitraum_von, abrechnungszeitraum_bis, dataGlobal, callback);
            if (check1) { return check1; }
            break;
        case 'abrechnungszeitraum_von':
            const check2 = checkAZ(key, jahr, abrechnungszeitraum_von, abrechnungszeitraum_bis, dataGlobal, callback);
            if (check2) { return check2; }
            break;
        case 'fremdbezug': {
            let message2: string = null;
            let message: string = checkFremdbezug(data, dataGlobal, (data: any) => {
                if ((data || {}).type !== 'error') {
                    // message2 = checkKennzahl('wasser_verbrauch_jahr', values, dataGlobal, callback, 'Unterschied: Fremdbezug ');
                    message2 = checkZaehlerwert(
                        key, values, IDs.ENT_ENERGIEDATEN_WASSER, dataGlobal, callback, 'Unterschied: Fremdbezug '
                    );
                    // return joinMessages([message2, message3]);
                }
                if (!message2 && typeof callback === 'function') {
                    callback(data);
                }
            });
            return message2 ? message2 : message;
        }
        case 'kalibrierung':
        // no break
        case 'messsystem':
            errMax = getPlausiValue('wasser.messsystem.limitString.max', 45);
            return limitString(key, value, errMax, onValueChange);
        case 'kosten_abwasser': {
            errMin = getPlausiValue('wasser.kosten_abwasser.error.min', 0);
            errMax = getPlausiValue('wasser.kosten_abwasser.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Kosten Abwasser [€] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            // const message = checkKennzahl('abwasser_kosten', values, dataGlobal, callback, 'Unterschied: Abwasserkosten ');
            return checkZaehlerwert(
                key, values, IDs.ENT_ENERGIEDATEN_WASSER, dataGlobal, callback, 'Unterschied: Abwasserkosten '
            );
            // return joinMessages([message, message2]);
        }
        case 'kosten_bezug': {
            errMin = getPlausiValue('wasser.kosten_bezug.error.min', 0);
            errMax = getPlausiValue('wasser.kosten_bezug.error.max', 9999999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Kosten Wasserbezug [€] müssen im Bereich [${errMin} - ${errMax}] liegen`;
            }
            // const message = checkKennzahl('wasserbezug_kosten', values, dataGlobal, callback, 'Unterschied: Wasserbezugskosten ');
            return checkZaehlerwert(
                key, values, IDs.ENT_ENERGIEDATEN_WASSER, dataGlobal, callback, 'Unterschied: Wasserbezugskosten '
            );
            // return joinMessages([message, message2]);
        }
        case 'regen_brunnennutzung': {
            let message2: string = null;
            let message: string = checkRegenBrunnennutzung(data, dataGlobal, (data: any) => {
                if ((data || {}).type !== 'error') {
                    // message2 = checkKennzahl('regen_brunnennutzung', values, dataGlobal, callback, 'Unterschied: Regennutzung ');
                    message2 = checkZaehlerwert(
                        key, values, IDs.ENT_ENERGIEDATEN_WASSER, dataGlobal, callback, 'Unterschied: Regennutzung '
                    );
                    // message2 = joinMessages([message2, message3]);
                }
                if (!message2 && typeof callback === 'function') {
                    callback(data);
                }
            });
            return message2 ? message2 : message;
        }
        case 'rueckerstattung':
            errMin = getPlausiValue('wasser.rueckerstattung.error.min', 0);
            errMax = getPlausiValue('wasser.rueckerstattung.error.max', 99999);
            if (isSomeKindOfNumber(value) && (+value < errMin || +value > errMax)) {
                processCallback(callback, { type: 'error' });
                return `Die Rückerstattung [€] muss im Bereich [${errMin} - ${errMax}] liegen`;
            }
            break;
    }
    return null;
}

// Der Abrechnungszeitraum reicht mehr als einen Monat in das Vorjahr
function isAZrma1MiVj(jahr: number, abrechnungszeitraum_von: number): boolean {
    if (jahr > 0 && abrechnungszeitraum_von > 0) {
        const abzVon = new Date(abrechnungszeitraum_von * 1000);
        const von_j = abzVon.getFullYear();
        const von_m = abzVon.getMonth() + 1;
        if (von_j < jahr && von_m < 12) {
            // console.log(jahr, von_j, von_m);
            return true;
        }
    }
    return false;
}

// Der Abrechnungszeitraum reicht mehr als einen Monat in das Folgejahr
function isAZrma1MiFj(jahr: number, abrechnungszeitraum_bis: number): boolean {
    if (jahr > 0 && abrechnungszeitraum_bis > 0) {
        const abzVon = new Date(abrechnungszeitraum_bis * 1000);
        const bis_j = abzVon.getFullYear();
        const bis_m = abzVon.getMonth() + 1;
        if (bis_j > jahr && bis_m > 1) {
            // console.log(jahr, bis_j, bis_m);
            return true;
        }
    }
    return false;
}

// Der Abrechnungszeitraum beträgt nicht ein Jahr.
function isAZbnej(jahr: number, abrechnungszeitraum_von: number, abrechnungszeitraum_bis: number): boolean {
    if (abrechnungszeitraum_von > 0) {
        const strAZVon = Moment.unix(abrechnungszeitraum_von).format('DD.MM.YYYY');
        if (strAZVon !== `01.01.${jahr}`) {
            return true;
        }
    }
    if (abrechnungszeitraum_bis > 0) {
        const strAZBis = Moment.unix(abrechnungszeitraum_bis).format('DD.MM.YYYY');
        if (strAZBis !== `31.12.${jahr}`) {
            return true;
        }
    }
    return false;
}

export function getMessageParams(validMsg: string): any {
    if (validMsg) {
        if (validMsg.includes(sysTxtAZMehrAlsEinMonat)) {
            // Der Abrechnungszeitraum reicht mehr als einen Monat in das Vorjahr/Folgejahr
            return { key: `${sysTxtAZMehrAlsEinMonat} Vorjahr/Folgejahr` };
        } else if (validMsg.includes(sysTxtSteuerAZNichtEinJahr)) {
            // Der Abrechnungszeitraum beträgt nicht ein Jahr.
            return { key: sysTxtSteuerAZNichtEinJahr };
        } else if (validMsg === sysTxtPvScope3_2) {
            return {
                isAlert: true,
                text: 'Sie versuchen gerade, eine im aktuellen Jahr angeschaffte Photovoltaik-Anlage als Teil Ihres Anlagevermögens in Scope 3.2 einzutragen. ' +
                    'Für die Erfassung der Emissionen, die durch die Nutzung einer PV-Anlage entstehen, sind unterschiedliche Herangehensweisen erlaubt. ' +
                    'Im E-Tool erfolgt die Berücksichtigung dieser Daten unter dem Punkt "2.1.1. Eigenstrom". ' +
                    'Sie geben hier einfach den generierten ("Gesamtproduktion") und eingespeisten Stromanteil ("Netzeinspeisung") Ihrer PV-Anlage für das aktuelle Jahr an, und das E-Tool berechnet auf dieser Basis die zu berücksichtigen Emissionen automatisch. ' +
                    'In der Datenauswertung finden Sie das Ergebnis unter Punkt Scope 3.3 ("Photovoltaik").'
            };
        } else if (validMsg === sysTxtKeinProduGewerbe) {
            return { key: sysTxtKeinProduGewerbe };
        }
    }
}

export function checkGewerbe(unternehmenValues: any, dataGlobal: any, callback: (data: any) => void): string {
    if (dataGlobal.MODUL_SELECTED === 'steuer') {
        const isProduGewebe: boolean = isProduzierendesGewerbe(dataGlobal, [unternehmenValues]);
        if (!isProduGewebe) {
            processCallback(callback, { type: 'error' });
            return sysTxtKeinProduGewerbe;
        }
    }
    return null;
}


